// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

import { client } from './client.gen.js';
import type {
  Client,
  ClientMeta,
  Options as Options2,
  RequestResult,
  TDataShape,
} from './client/index.js';
import type {
  AddPaymentBatchItemsData,
  AddPaymentBatchItemsErrors,
  AddPaymentBatchItemsResponses,
  CancelPaymentBatchData,
  CancelPaymentBatchErrors,
  CancelPaymentBatchResponses,
  CheckHealthData,
  CheckHealthErrors,
  CheckHealthResponses,
  CheckUpstreamHealthData,
  CheckUpstreamHealthErrors,
  CheckUpstreamHealthResponses,
  ClonePaymentBatchData,
  ClonePaymentBatchErrors,
  ClonePaymentBatchResponses,
  CollectBasicInfoData,
  CollectBasicInfoErrors,
  CollectBasicInfoResponses,
  CreateAccountData,
  CreateAccountErrors,
  CreateAccountResponses,
  CreateBeneficiaryBankAccountData,
  CreateBeneficiaryBankAccountErrors,
  CreateBeneficiaryBankAccountResponses,
  CreateCorporateBeneficiaryData,
  CreateCorporateBeneficiaryErrors,
  CreateCorporateBeneficiaryResponses,
  CreateExchangeQuoteData,
  CreateExchangeQuoteErrors,
  CreateExchangeQuoteResponses,
  CreateExchangeTransactionData,
  CreateExchangeTransactionErrors,
  CreateExchangeTransactionResponses,
  CreateExternalTransferData,
  CreateExternalTransferErrors,
  CreateExternalTransferResponses,
  CreateIndividualBeneficiaryData,
  CreateIndividualBeneficiaryErrors,
  CreateIndividualBeneficiaryResponses,
  CreateInternalTransferData,
  CreateInternalTransferErrors,
  CreateInternalTransferResponses,
  CreateOrganizationData,
  CreateOrganizationErrors,
  CreateOrganizationResponses,
  CreatePaymentBatchData,
  CreatePaymentBatchErrors,
  CreatePaymentBatchResponses,
  CreateReportData,
  CreateReportErrors,
  CreateReportResponses,
  DeactivateOrganizationMemberData,
  DeactivateOrganizationMemberErrors,
  DeactivateOrganizationMemberResponses,
  DecodeTemporalPayloadsData,
  DecodeTemporalPayloadsErrors,
  DecodeTemporalPayloadsResponses,
  DeleteAllOtherSessionsData,
  DeleteAllOtherSessionsErrors,
  DeleteAllOtherSessionsResponses,
  DeleteBeneficiaryBankAccountData,
  DeleteBeneficiaryBankAccountErrors,
  DeleteBeneficiaryBankAccountResponses,
  DeleteBeneficiaryData,
  DeleteBeneficiaryErrors,
  DeleteBeneficiaryResponses,
  DeleteCurrentSessionData,
  DeleteCurrentSessionErrors,
  DeleteCurrentSessionResponses,
  DeleteDocumentData,
  DeleteDocumentErrors,
  DeletePaymentBatchData,
  DeletePaymentBatchErrors,
  DeletePaymentBatchResponses,
  DeleteSessionData,
  DeleteSessionErrors,
  DeleteSessionResponses,
  DryRunExternalTransferData,
  DryRunExternalTransferErrors,
  DryRunExternalTransferResponses,
  DryRunInternalTransferData,
  DryRunInternalTransferErrors,
  DryRunInternalTransferResponses,
  DryRunPaymentBatchData,
  DryRunPaymentBatchErrors,
  DryRunPaymentBatchResponses,
  EvaluateLoginData,
  EvaluateLoginErrors,
  EvaluateLoginResponses,
  EvaluateRegistrationData,
  EvaluateRegistrationErrors,
  EvaluateRegistrationResponses,
  ExportAccountStatementData,
  ExportAccountStatementErrors,
  ExportAccountStatementResponses,
  ExportGenericTransactionConfirmationData,
  ExportGenericTransactionConfirmationErrors,
  ExportGenericTransactionConfirmationResponses,
  ExportIncomingTransferConfirmationData,
  ExportIncomingTransferConfirmationErrors,
  ExportIncomingTransferConfirmationResponses,
  ExportOutgoingTransferConfirmationData,
  ExportOutgoingTransferConfirmationErrors,
  ExportOutgoingTransferConfirmationResponses,
  ForceApprovePaymentBatchItemData,
  ForceApprovePaymentBatchItemErrors,
  ForceApprovePaymentBatchItemResponses,
  ForceApprovePaymentBatchItemsData,
  ForceApprovePaymentBatchItemsErrors,
  ForceApprovePaymentBatchItemsResponses,
  GenerateKybLinkData,
  GenerateKybLinkErrors,
  GenerateKybLinkResponses,
  GenerateKycLinkData,
  GenerateKycLinkErrors,
  GenerateKycLinkResponses,
  GetAccountDepositInformationData,
  GetAccountDepositInformationErrors,
  GetAccountDepositInformationResponses,
  GetAccountStatementsData,
  GetAccountStatementsErrors,
  GetAccountStatementsResponses,
  GetActiveSessionsData,
  GetActiveSessionsErrors,
  GetActiveSessionsResponses,
  GetBeneficiaryBankAccountRequirementsData,
  GetBeneficiaryBankAccountRequirementsErrors,
  GetBeneficiaryBankAccountRequirementsResponses,
  GetChallengeStatusData,
  GetChallengeStatusErrors,
  GetChallengeStatusResponses,
  GetClientData,
  GetClientErrors,
  GetClientResponses,
  GetDefaultMetricsData,
  GetDefaultMetricsErrors,
  GetDefaultMetricsResponses,
  GetDocumentUploadUrlData,
  GetDocumentUploadUrlErrors,
  GetDocumentUploadUrlResponses,
  GetExchangeTransactionData,
  GetExchangeTransactionErrors,
  GetExchangeTransactionResponses,
  GetExpressMetricsData,
  GetExpressMetricsErrors,
  GetExpressMetricsResponses,
  GetGenericTransactionByIdData,
  GetGenericTransactionByIdErrors,
  GetGenericTransactionByIdResponses,
  GetGuardianStatusData,
  GetGuardianStatusErrors,
  GetGuardianStatusResponses,
  GetIncomingTransferByIdData,
  GetIncomingTransferByIdErrors,
  GetIncomingTransferByIdResponses,
  GetKybStatusData,
  GetKybStatusErrors,
  GetKybStatusResponses,
  GetKycStatusData,
  GetKycStatusErrors,
  GetKycStatusResponses,
  GetLivenessChallengeStatusData,
  GetLivenessChallengeStatusErrors,
  GetLivenessChallengeStatusResponses,
  GetNotificationPreferencesData,
  GetNotificationPreferencesErrors,
  GetNotificationPreferencesResponses,
  GetNovuBootstrapInfoData,
  GetNovuBootstrapInfoErrors,
  GetNovuBootstrapInfoResponses,
  GetOutgoingTransferByIdData,
  GetOutgoingTransferByIdErrors,
  GetOutgoingTransferByIdResponses,
  GetOutgoingTransferLimitsData,
  GetOutgoingTransferLimitsErrors,
  GetOutgoingTransferLimitsResponses,
  GetPaymentBatchData,
  GetPaymentBatchErrors,
  GetPaymentBatchResponses,
  GetProfilePictureUploadUrlData,
  GetProfilePictureUploadUrlErrors,
  GetProfilePictureUploadUrlResponses,
  GetProfilePictureUrlData,
  GetProfilePictureUrlErrors,
  GetProfilePictureUrlResponses,
  GetReachableTransferSchemesData,
  GetReachableTransferSchemesErrors,
  GetReachableTransferSchemesResponses,
  GetReportDownloadUrlData,
  GetReportDownloadUrlErrors,
  GetReportDownloadUrlResponses,
  GetSddAccountLimitsData,
  GetSddAccountLimitsErrors,
  GetSddAccountLimitsResponses,
  GetTransferDateMetadataData,
  GetTransferDateMetadataErrors,
  GetTransferDateMetadataResponses,
  GetUserByIdData,
  GetUserByIdErrors,
  GetUserByIdResponses,
  GetUserContextsData,
  GetUserContextsErrors,
  GetUserContextsResponses,
  IdentifyNovuSubscriberData,
  IdentifyNovuSubscriberErrors,
  IdentifyNovuSubscriberResponses,
  InitiateEmailChangeChallengeData,
  InitiateEmailChangeChallengeErrors,
  InitiatePaymentBatchSubmitChallengeData,
  InitiatePaymentBatchSubmitChallengeErrors,
  InitiatePaymentBatchSubmitChallengeResponses,
  InitiatePhoneChallengeData,
  InitiatePhoneChallengeErrors,
  InitiatePhoneChallengeResponses,
  InviteOrganizationMemberData,
  InviteOrganizationMemberErrors,
  InviteOrganizationMemberResponses,
  ListAccountsData,
  ListAccountsErrors,
  ListAccountsResponses,
  ListBeneficiariesData,
  ListBeneficiariesErrors,
  ListBeneficiariesResponses,
  ListBeneficiaryBankAccountsData,
  ListBeneficiaryBankAccountsErrors,
  ListBeneficiaryBankAccountsResponses,
  ListClientRelationsData,
  ListClientRelationsErrors,
  ListClientRelationsResponses,
  ListCommonTransferReasonsData,
  ListCommonTransferReasonsErrors,
  ListCommonTransferReasonsResponses,
  ListDocumentsData,
  ListDocumentsErrors,
  ListDocumentsResponses,
  ListGenericTransactionsData,
  ListGenericTransactionsErrors,
  ListGenericTransactionsResponses,
  ListIncomingTransfersData,
  ListIncomingTransfersErrors,
  ListIncomingTransfersResponses,
  ListOrganizationMembersData,
  ListOrganizationMembersErrors,
  ListOrganizationMembersResponses,
  ListOutgoingTransfersData,
  ListOutgoingTransfersErrors,
  ListOutgoingTransfersResponses,
  ListPaymentBatchesData,
  ListPaymentBatchesErrors,
  ListPaymentBatchesResponses,
  ListPaymentBatchItemsData,
  ListPaymentBatchItemsErrors,
  ListPaymentBatchItemsResponses,
  ListReportsData,
  ListReportsErrors,
  ListReportsResponses,
  ListTransferReasonsData,
  ListTransferReasonsErrors,
  ListTransferReasonsResponses,
  ReceiveAuth0LogStreamData,
  ReceiveAuth0LogStreamErrors,
  ReceiveAuth0LogStreamResponses,
  ReceiveAuth0WebhookData,
  ReceiveAuth0WebhookErrors,
  ReceiveAuth0WebhookResponses,
  ReceiveBackchannelLogoutData,
  ReceiveBackchannelLogoutErrors,
  ReceiveBackchannelLogoutResponses,
  ReceiveIntegratedFinanceWebhookData,
  ReceiveIntegratedFinanceWebhookErrors,
  ReceiveIntegratedFinanceWebhookResponses,
  ReceiveInventiLiquidityWebhookData,
  ReceiveInventiLiquidityWebhookErrors,
  ReceiveInventiLiquidityWebhookResponses,
  ReceiveInventiWebhookData,
  ReceiveInventiWebhookErrors,
  ReceiveInventiWebhookResponses,
  ReceiveSumsubWebhookData,
  ReceiveSumsubWebhookErrors,
  ReceiveSumsubWebhookResponses,
  RefreshExchangeQuoteData,
  RefreshExchangeQuoteErrors,
  RefreshExchangeQuoteResponses,
  RemoveDeviceTokenData,
  RemoveDeviceTokenErrors,
  RemoveDeviceTokenResponses,
  RemovePaymentBatchItemsData,
  RemovePaymentBatchItemsErrors,
  RemovePaymentBatchItemsResponses,
  ResendEmailChallengeData,
  ResendEmailChallengeErrors,
  ResendEmailChallengeResponses,
  ResendOrganizationInvitationData,
  ResendOrganizationInvitationErrors,
  ResendOrganizationInvitationResponses,
  ResolveOutgoingTransferChallengeData,
  ResolveOutgoingTransferChallengeErrors,
  ResolveOutgoingTransferChallengeResponses,
  ResolvePaymentBatchSubmitChallengeData,
  ResolvePaymentBatchSubmitChallengeErrors,
  ResolvePaymentBatchSubmitChallengeResponses,
  RevokeOrganizationInvitationData,
  RevokeOrganizationInvitationErrors,
  RevokeOrganizationInvitationResponses,
  SetAccountAliasData,
  SetAccountAliasErrors,
  SetAccountAliasResponses,
  SetAccountLivenessLockData,
  SetAccountLivenessLockErrors,
  SetAccountLivenessLockResponses,
  SetAccountStatusData,
  SetAccountStatusErrors,
  SetAccountStatusResponses,
  SetDeviceTokenData,
  SetDeviceTokenErrors,
  SetDeviceTokenResponses,
  SetTransferLimitsData,
  SetTransferLimitsErrors,
  SetTransferLimitsResponses,
  StartLivenessChallengeData,
  StartLivenessChallengeErrors,
  StartLivenessChallengeResponses,
  StartSddCreditorCollectionData,
  StartSddCreditorCollectionErrors,
  StartSddCreditorCollectionResponses,
  TriggerNotificationData,
  TriggerNotificationErrors,
  TriggerNotificationResponses,
  UpdateBeneficiaryBankAccountData,
  UpdateBeneficiaryBankAccountErrors,
  UpdateBeneficiaryBankAccountResponses,
  UpdateBeneficiaryDetailsData,
  UpdateBeneficiaryDetailsErrors,
  UpdateBeneficiaryDetailsResponses,
  UpdateNotificationPreferencesData,
  UpdateNotificationPreferencesErrors,
  UpdateNotificationPreferencesResponses,
  UpdatePaymentBatchData,
  UpdatePaymentBatchErrors,
  UpdatePaymentBatchItemData,
  UpdatePaymentBatchItemErrors,
  UpdatePaymentBatchItemResponses,
  UpdatePaymentBatchResponses,
  VerifyBeneficiaryDataData,
  VerifyBeneficiaryDataErrors,
  VerifyBeneficiaryDataResponses,
  VerifyEmailChangeChallengeData,
  VerifyEmailChangeChallengeErrors,
  VerifyPaymentBatchData,
  VerifyPaymentBatchErrors,
  VerifyPaymentBatchResponses,
  VerifyPhoneChallengeData,
  VerifyPhoneChallengeErrors,
  VerifyPhoneChallengeResponses,
} from './types.gen.js';
import {
  addPaymentBatchItemsResponse,
  cancelPaymentBatchResponse,
  checkHealthResponse,
  checkUpstreamHealthResponse,
  clonePaymentBatchResponse,
  collectBasicInfoResponse,
  createAccountResponse,
  createBeneficiaryBankAccountResponse,
  createCorporateBeneficiaryResponse,
  createExchangeQuoteResponse,
  createExchangeTransactionResponse,
  createExternalTransferResponse,
  createIndividualBeneficiaryResponse,
  createInternalTransferResponse,
  createOrganizationResponse,
  createPaymentBatchResponse,
  createReportResponse,
  deactivateOrganizationMemberResponse,
  decodeTemporalPayloadsResponse,
  deleteAllOtherSessionsResponse,
  deleteBeneficiaryBankAccountResponse,
  deleteBeneficiaryResponse,
  deleteCurrentSessionResponse,
  deletePaymentBatchResponse,
  deleteSessionResponse,
  dryRunExternalTransferResponse,
  dryRunInternalTransferResponse,
  dryRunPaymentBatchResponse,
  evaluateLoginResponse,
  evaluateRegistrationResponse,
  exportAccountStatementResponse,
  exportGenericTransactionConfirmationResponse,
  exportIncomingTransferConfirmationResponse,
  exportOutgoingTransferConfirmationResponse,
  forceApprovePaymentBatchItemResponse,
  forceApprovePaymentBatchItemsResponse,
  generateKybLinkResponse,
  generateKycLinkResponse,
  getAccountDepositInformationResponse,
  getAccountStatementsResponse,
  getActiveSessionsResponse,
  getBeneficiaryBankAccountRequirementsResponse,
  getChallengeStatusResponse,
  getClientResponse,
  getDefaultMetricsResponse,
  getDocumentUploadUrlResponse,
  getExchangeTransactionResponse,
  getExpressMetricsResponse,
  getGenericTransactionByIdResponse,
  getGuardianStatusResponse,
  getIncomingTransferByIdResponse,
  getKybStatusResponse,
  getKycStatusResponse,
  getLivenessChallengeStatusResponse,
  getNotificationPreferencesResponse,
  getNovuBootstrapInfoResponse,
  getOutgoingTransferByIdResponse,
  getOutgoingTransferLimitsResponse,
  getPaymentBatchResponse,
  getProfilePictureUploadUrlResponse,
  getProfilePictureUrlResponse,
  getReachableTransferSchemesResponse,
  getReportDownloadUrlResponse,
  getSddAccountLimitsResponse,
  getTransferDateMetadataResponse,
  getUserByIdResponse,
  getUserContextsResponse,
  identifyNovuSubscriberResponse,
  initiatePaymentBatchSubmitChallengeResponse,
  initiatePhoneChallengeResponse,
  inviteOrganizationMemberResponse,
  listAccountsResponse,
  listBeneficiariesResponse,
  listBeneficiaryBankAccountsResponse,
  listClientRelationsResponse,
  listCommonTransferReasonsResponse,
  listDocumentsResponse,
  listGenericTransactionsResponse,
  listIncomingTransfersResponse,
  listOrganizationMembersResponse,
  listOutgoingTransfersResponse,
  listPaymentBatchesResponse,
  listPaymentBatchItemsResponse,
  listReportsResponse,
  listTransferReasonsResponse,
  receiveAuth0LogStreamResponse,
  receiveAuth0WebhookResponse,
  receiveIntegratedFinanceWebhookResponse,
  receiveInventiLiquidityWebhookResponse,
  receiveInventiWebhookResponse,
  receiveSumsubWebhookResponse,
  refreshExchangeQuoteResponse,
  removePaymentBatchItemsResponse,
  resendEmailChallengeResponse,
  resendOrganizationInvitationResponse,
  resolveOutgoingTransferChallengeResponse,
  resolvePaymentBatchSubmitChallengeResponse,
  revokeOrganizationInvitationResponse,
  setAccountAliasResponse,
  setAccountLivenessLockResponse,
  setAccountStatusResponse,
  setTransferLimitsResponse,
  startLivenessChallengeResponse,
  startSddCreditorCollectionResponse,
  triggerNotificationResponse,
  updateBeneficiaryBankAccountResponse,
  updateBeneficiaryDetailsResponse,
  updatePaymentBatchItemResponse,
  updatePaymentBatchResponse,
  verifyBeneficiaryDataResponse,
  verifyPaymentBatchResponse,
  verifyPhoneChallengeResponse,
  zAddPaymentBatchItemsBody,
  zAddPaymentBatchItemsHeaders,
  zAddPaymentBatchItemsPath,
  zCancelPaymentBatchHeaders,
  zCancelPaymentBatchPath,
  zClonePaymentBatchBody,
  zClonePaymentBatchHeaders,
  zClonePaymentBatchPath,
  zCollectBasicInfoBody,
  zCollectBasicInfoHeaders,
  zCollectBasicInfoPath,
  zCreateAccountBody,
  zCreateAccountHeaders,
  zCreateBeneficiaryBankAccountBody,
  zCreateBeneficiaryBankAccountHeaders,
  zCreateBeneficiaryBankAccountPath,
  zCreateCorporateBeneficiaryBody,
  zCreateCorporateBeneficiaryHeaders,
  zCreateExchangeQuoteBody,
  zCreateExchangeQuoteHeaders,
  zCreateExchangeTransactionBody,
  zCreateExchangeTransactionHeaders,
  zCreateExternalTransferBody,
  zCreateExternalTransferHeaders,
  zCreateIndividualBeneficiaryBody,
  zCreateIndividualBeneficiaryHeaders,
  zCreateInternalTransferBody,
  zCreateInternalTransferHeaders,
  zCreateOrganizationBody,
  zCreateOrganizationHeaders,
  zCreatePaymentBatchBody,
  zCreatePaymentBatchHeaders,
  zCreateReportBody,
  zCreateReportHeaders,
  zDeactivateOrganizationMemberHeaders,
  zDeactivateOrganizationMemberPath,
  zDecodeTemporalPayloadsBody,
  zDeleteAllOtherSessionsHeaders,
  zDeleteBeneficiaryBankAccountHeaders,
  zDeleteBeneficiaryBankAccountPath,
  zDeleteBeneficiaryHeaders,
  zDeleteBeneficiaryPath,
  zDeleteCurrentSessionHeaders,
  zDeleteDocumentHeaders,
  zDeleteDocumentPath,
  zDeletePaymentBatchHeaders,
  zDeletePaymentBatchPath,
  zDeleteSessionHeaders,
  zDeleteSessionPath,
  zDryRunExternalTransferBody,
  zDryRunExternalTransferHeaders,
  zDryRunInternalTransferBody,
  zDryRunInternalTransferHeaders,
  zDryRunPaymentBatchHeaders,
  zDryRunPaymentBatchPath,
  zEvaluateLoginBody,
  zEvaluateLoginPath,
  zEvaluateRegistrationBody,
  zExportAccountStatementBody,
  zExportAccountStatementHeaders,
  zExportAccountStatementPath,
  zExportGenericTransactionConfirmationHeaders,
  zExportGenericTransactionConfirmationPath,
  zExportIncomingTransferConfirmationHeaders,
  zExportIncomingTransferConfirmationPath,
  zExportOutgoingTransferConfirmationHeaders,
  zExportOutgoingTransferConfirmationPath,
  zForceApprovePaymentBatchItemHeaders,
  zForceApprovePaymentBatchItemPath,
  zForceApprovePaymentBatchItemsBody,
  zForceApprovePaymentBatchItemsHeaders,
  zForceApprovePaymentBatchItemsPath,
  zGenerateKybLinkHeaders,
  zGenerateKybLinkPath,
  zGenerateKycLinkBody,
  zGenerateKycLinkHeaders,
  zGenerateKycLinkPath,
  zGetAccountDepositInformationHeaders,
  zGetAccountDepositInformationPath,
  zGetAccountStatementsHeaders,
  zGetAccountStatementsPath,
  zGetAccountStatementsQuery,
  zGetActiveSessionsHeaders,
  zGetBeneficiaryBankAccountRequirementsHeaders,
  zGetBeneficiaryBankAccountRequirementsQuery,
  zGetChallengeStatusHeaders,
  zGetChallengeStatusPath,
  zGetClientHeaders,
  zGetClientPath,
  zGetDocumentUploadUrlHeaders,
  zGetDocumentUploadUrlPath,
  zGetDocumentUploadUrlQuery,
  zGetExchangeTransactionHeaders,
  zGetExchangeTransactionPath,
  zGetGenericTransactionByIdHeaders,
  zGetGenericTransactionByIdPath,
  zGetGuardianStatusHeaders,
  zGetIncomingTransferByIdHeaders,
  zGetIncomingTransferByIdPath,
  zGetKybStatusHeaders,
  zGetKybStatusPath,
  zGetKycStatusHeaders,
  zGetKycStatusPath,
  zGetLivenessChallengeStatusHeaders,
  zGetLivenessChallengeStatusPath,
  zGetNotificationPreferencesHeaders,
  zGetNovuBootstrapInfoHeaders,
  zGetOutgoingTransferByIdHeaders,
  zGetOutgoingTransferByIdPath,
  zGetOutgoingTransferLimitsHeaders,
  zGetOutgoingTransferLimitsQuery,
  zGetPaymentBatchHeaders,
  zGetPaymentBatchPath,
  zGetProfilePictureUploadUrlHeaders,
  zGetProfilePictureUrlHeaders,
  zGetProfilePictureUrlPath,
  zGetReachableTransferSchemesHeaders,
  zGetReachableTransferSchemesQuery,
  zGetReportDownloadUrlHeaders,
  zGetReportDownloadUrlPath,
  zGetSddAccountLimitsHeaders,
  zGetSddAccountLimitsQuery,
  zGetTransferDateMetadataHeaders,
  zGetTransferDateMetadataQuery,
  zGetUserByIdHeaders,
  zGetUserByIdPath,
  zGetUserContextsHeaders,
  zIdentifyNovuSubscriberBody,
  zIdentifyNovuSubscriberHeaders,
  zInitiateEmailChangeChallengeBody,
  zInitiateEmailChangeChallengeHeaders,
  zInitiatePaymentBatchSubmitChallengeHeaders,
  zInitiatePaymentBatchSubmitChallengePath,
  zInitiatePhoneChallengeBody,
  zInitiatePhoneChallengeHeaders,
  zInviteOrganizationMemberBody,
  zInviteOrganizationMemberHeaders,
  zInviteOrganizationMemberPath,
  zListAccountsHeaders,
  zListAccountsQuery,
  zListBeneficiariesHeaders,
  zListBeneficiariesQuery,
  zListBeneficiaryBankAccountsHeaders,
  zListBeneficiaryBankAccountsPath,
  zListBeneficiaryBankAccountsQuery,
  zListClientRelationsHeaders,
  zListClientRelationsPath,
  zListClientRelationsQuery,
  zListCommonTransferReasonsHeaders,
  zListCommonTransferReasonsQuery,
  zListDocumentsHeaders,
  zListDocumentsPath,
  zListGenericTransactionsHeaders,
  zListGenericTransactionsQuery,
  zListIncomingTransfersHeaders,
  zListIncomingTransfersQuery,
  zListOrganizationMembersHeaders,
  zListOrganizationMembersPath,
  zListOutgoingTransfersHeaders,
  zListOutgoingTransfersQuery,
  zListPaymentBatchesHeaders,
  zListPaymentBatchesQuery,
  zListPaymentBatchItemsHeaders,
  zListPaymentBatchItemsPath,
  zListPaymentBatchItemsQuery,
  zListReportsHeaders,
  zListReportsQuery,
  zListTransferReasonsHeaders,
  zListTransferReasonsQuery,
  zReceiveAuth0LogStreamBody,
  zReceiveAuth0WebhookBody,
  zReceiveIntegratedFinanceWebhookBody,
  zReceiveIntegratedFinanceWebhookHeaders,
  zReceiveInventiLiquidityWebhookBody,
  zReceiveInventiLiquidityWebhookHeaders,
  zReceiveInventiWebhookBody,
  zReceiveInventiWebhookHeaders,
  zReceiveSumsubWebhookHeaders,
  zRefreshExchangeQuoteBody,
  zRefreshExchangeQuoteHeaders,
  zRefreshExchangeQuotePath,
  zRemoveDeviceTokenBody,
  zRemoveDeviceTokenHeaders,
  zRemovePaymentBatchItemsBody,
  zRemovePaymentBatchItemsHeaders,
  zRemovePaymentBatchItemsPath,
  zResendEmailChallengeHeaders,
  zResendOrganizationInvitationHeaders,
  zResendOrganizationInvitationPath,
  zResolveOutgoingTransferChallengeBody,
  zResolveOutgoingTransferChallengeHeaders,
  zResolvePaymentBatchSubmitChallengeBody,
  zResolvePaymentBatchSubmitChallengeHeaders,
  zResolvePaymentBatchSubmitChallengePath,
  zRevokeOrganizationInvitationHeaders,
  zRevokeOrganizationInvitationPath,
  zSetAccountAliasBody,
  zSetAccountAliasHeaders,
  zSetAccountAliasPath,
  zSetAccountLivenessLockPath,
  zSetAccountStatusBody,
  zSetAccountStatusHeaders,
  zSetAccountStatusPath,
  zSetDeviceTokenBody,
  zSetDeviceTokenHeaders,
  zSetTransferLimitsBody,
  zSetTransferLimitsHeaders,
  zStartLivenessChallengeBody,
  zStartLivenessChallengeHeaders,
  zStartSddCreditorCollectionHeaders,
  zTriggerNotificationBody,
  zTriggerNotificationHeaders,
  zUpdateBeneficiaryBankAccountBody,
  zUpdateBeneficiaryBankAccountHeaders,
  zUpdateBeneficiaryBankAccountPath,
  zUpdateBeneficiaryDetailsBody,
  zUpdateBeneficiaryDetailsHeaders,
  zUpdateBeneficiaryDetailsPath,
  zUpdateNotificationPreferencesBody,
  zUpdateNotificationPreferencesHeaders,
  zUpdatePaymentBatchBody,
  zUpdatePaymentBatchHeaders,
  zUpdatePaymentBatchItemBody,
  zUpdatePaymentBatchItemHeaders,
  zUpdatePaymentBatchItemPath,
  zUpdatePaymentBatchPath,
  zVerifyBeneficiaryDataBody,
  zVerifyBeneficiaryDataHeaders,
  zVerifyEmailChangeChallengeBody,
  zVerifyEmailChangeChallengeHeaders,
  zVerifyPaymentBatchHeaders,
  zVerifyPaymentBatchPath,
  zVerifyPhoneChallengeBody,
  zVerifyPhoneChallengeHeaders,
} from './zod.gen.js';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

class HeyApiClient {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry<T> {
  private readonly defaultKey = 'default';

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new PeanudsApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

export class PeanudsApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry<PeanudsApi> = new HeyApiRegistry<PeanudsApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    PeanudsApi.__registry.set(this, args?.key);
  }

  /**
   * List accounts
   *
   * Retrieves a paginated list of accounts for the authenticated user's client. Supports filtering by currency, status, alias, and IBAN. Users can only access accounts associated with their own client.
   */
  public listAccounts<ThrowOnError extends boolean = false>(
    options: Options<ListAccountsData, ThrowOnError>,
  ): RequestResult<ListAccountsResponses, ListAccountsErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      ListAccountsResponses,
      ListAccountsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListAccountsHeaders,
            path: z.never().optional(),
            query: zListAccountsQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listAccountsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/accounts',
      ...options,
    });
  }

  /**
   * Create account
   *
   * Creates a new account for the authenticated user.
   */
  public createAccount<ThrowOnError extends boolean = false>(
    options: Options<CreateAccountData, ThrowOnError>,
  ): RequestResult<CreateAccountResponses, CreateAccountErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      CreateAccountResponses,
      CreateAccountErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zCreateAccountBody,
            headers: zCreateAccountHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await createAccountResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/accounts',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get account statements
   *
   * Returns account statements for a specific account. This endpoint is JSON-only. Use POST /v1/accounts/{id}/statements/actions/export for PDF statement exports.
   */
  public getAccountStatements<ThrowOnError extends boolean = false>(
    options: Options<GetAccountStatementsData, ThrowOnError>,
  ): RequestResult<GetAccountStatementsResponses, GetAccountStatementsErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetAccountStatementsResponses,
      GetAccountStatementsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetAccountStatementsHeaders,
            path: zGetAccountStatementsPath,
            query: zGetAccountStatementsQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getAccountStatementsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/accounts/{id}/statements',
      ...options,
    });
  }

  /**
   * Get account deposit information
   *
   * Returns per-scheme deposit information (sepa, sepa-instant, sepa-target-2, internal) for a specific account. Used by the frontend to obtain the account's BIC and bank address. Users can only access accounts associated with their own client.
   */
  public getAccountDepositInformation<ThrowOnError extends boolean = false>(
    options: Options<GetAccountDepositInformationData, ThrowOnError>,
  ): RequestResult<
    GetAccountDepositInformationResponses,
    GetAccountDepositInformationErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).get<
      GetAccountDepositInformationResponses,
      GetAccountDepositInformationErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetAccountDepositInformationHeaders,
            path: zGetAccountDepositInformationPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await getAccountDepositInformationResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/accounts/{id}/deposit-information',
      ...options,
    });
  }

  /**
   * Export account statement
   *
   * Generates an account statement export for a specific period. For now, only PDF exports are supported via Accept: application/pdf. This replaces the previous PDF response branch on GET /v1/accounts/{id}/statements.
   */
  public exportAccountStatement<ThrowOnError extends boolean = false>(
    options: Options<ExportAccountStatementData, ThrowOnError>,
  ): RequestResult<ExportAccountStatementResponses, ExportAccountStatementErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      ExportAccountStatementResponses,
      ExportAccountStatementErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zExportAccountStatementBody,
            headers: zExportAccountStatementHeaders,
            path: zExportAccountStatementPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'blob',
      responseValidator: async (data) => await exportAccountStatementResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/accounts/{id}/statements/actions/export',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Set account alias
   *
   * Sets the alias of an account. Only the 'alias' field can be modified. Any other fields in the request will cause a validation error. Send an empty string to clear the alias. Users can only update accounts associated with their own client.
   */
  public setAccountAlias<ThrowOnError extends boolean = false>(
    options: Options<SetAccountAliasData, ThrowOnError>,
  ): RequestResult<SetAccountAliasResponses, SetAccountAliasErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      SetAccountAliasResponses,
      SetAccountAliasErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zSetAccountAliasBody,
            headers: zSetAccountAliasHeaders,
            path: zSetAccountAliasPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await setAccountAliasResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/accounts/{id}/actions/set-alias',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Set account status
   *
   * Sets the status of an account. Only the 'status' field can be modified. Can only be set to "inactive" or "suspended" if the account is active, and can only be set to "active" if the account is inactive or suspended.Setting the status to "closed" will close the account permanently.Users can only update accounts associated with their own client.
   */
  public setAccountStatus<ThrowOnError extends boolean = false>(
    options: Options<SetAccountStatusData, ThrowOnError>,
  ): RequestResult<SetAccountStatusResponses, SetAccountStatusErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      SetAccountStatusResponses,
      SetAccountStatusErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zSetAccountStatusBody,
            headers: zSetAccountStatusHeaders,
            path: zSetAccountStatusPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await setAccountStatusResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/accounts/{id}/actions/set-status',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * List beneficiaries
   *
   * Retrieves a paginated list of beneficiaries for the authenticated user's client. The response includes beneficiary bank accounts. Users can only access beneficiaries associated with their own client.
   */
  public listBeneficiaries<ThrowOnError extends boolean = false>(
    options: Options<ListBeneficiariesData, ThrowOnError>,
  ): RequestResult<ListBeneficiariesResponses, ListBeneficiariesErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      ListBeneficiariesResponses,
      ListBeneficiariesErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListBeneficiariesHeaders,
            path: z.never().optional(),
            query: zListBeneficiariesQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listBeneficiariesResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/beneficiaries',
      ...options,
    });
  }

  /**
   * Create an individual beneficiary
   *
   * Creates a new individual beneficiary for the authenticated user's client. Requires first name, last name, and address information.
   */
  public createIndividualBeneficiary<ThrowOnError extends boolean = false>(
    options: Options<CreateIndividualBeneficiaryData, ThrowOnError>,
  ): RequestResult<
    CreateIndividualBeneficiaryResponses,
    CreateIndividualBeneficiaryErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      CreateIndividualBeneficiaryResponses,
      CreateIndividualBeneficiaryErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zCreateIndividualBeneficiaryBody,
            headers: zCreateIndividualBeneficiaryHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await createIndividualBeneficiaryResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/beneficiaries/individual',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Create a corporate beneficiary
   *
   * Creates a new corporate beneficiary for the authenticated user's client. Requires legal name and address information.
   */
  public createCorporateBeneficiary<ThrowOnError extends boolean = false>(
    options: Options<CreateCorporateBeneficiaryData, ThrowOnError>,
  ): RequestResult<
    CreateCorporateBeneficiaryResponses,
    CreateCorporateBeneficiaryErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      CreateCorporateBeneficiaryResponses,
      CreateCorporateBeneficiaryErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zCreateCorporateBeneficiaryBody,
            headers: zCreateCorporateBeneficiaryHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await createCorporateBeneficiaryResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/beneficiaries/corporate',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Verify beneficiary data
   *
   * Verifies that a beneficiary's name matches their bank account data/IBAN using VoP (Verification of Payee) for SEPA accounts.
   */
  public verifyBeneficiaryData<ThrowOnError extends boolean = false>(
    options: Options<VerifyBeneficiaryDataData, ThrowOnError>,
  ): RequestResult<VerifyBeneficiaryDataResponses, VerifyBeneficiaryDataErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      VerifyBeneficiaryDataResponses,
      VerifyBeneficiaryDataErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zVerifyBeneficiaryDataBody,
            headers: zVerifyBeneficiaryDataHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await verifyBeneficiaryDataResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/beneficiaries/verify-data',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get bank account validation requirements
   *
   * Retrieves validation requirements for beneficiary bank account fields based on the specified currency and country combination. This helps determine which fields are required, optional, or prohibited for different account types.
   */
  public getBeneficiaryBankAccountRequirements<ThrowOnError extends boolean = false>(
    options: Options<GetBeneficiaryBankAccountRequirementsData, ThrowOnError>,
  ): RequestResult<
    GetBeneficiaryBankAccountRequirementsResponses,
    GetBeneficiaryBankAccountRequirementsErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).get<
      GetBeneficiaryBankAccountRequirementsResponses,
      GetBeneficiaryBankAccountRequirementsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetBeneficiaryBankAccountRequirementsHeaders,
            path: z.never().optional(),
            query: zGetBeneficiaryBankAccountRequirementsQuery,
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await getBeneficiaryBankAccountRequirementsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/beneficiaries/bank-accounts/requirements',
      ...options,
    });
  }

  /**
   * List beneficiary bank accounts
   *
   * Retrieves a paginated list of bank accounts for a specific beneficiary, served from the local mirror. Deleted bank accounts are excluded, and a deleted beneficiary answers with an empty page. The beneficiary must belong to the authenticated user's client. Users can only access bank accounts for beneficiaries associated with their own client.
   */
  public listBeneficiaryBankAccounts<ThrowOnError extends boolean = false>(
    options: Options<ListBeneficiaryBankAccountsData, ThrowOnError>,
  ): RequestResult<
    ListBeneficiaryBankAccountsResponses,
    ListBeneficiaryBankAccountsErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).get<
      ListBeneficiaryBankAccountsResponses,
      ListBeneficiaryBankAccountsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListBeneficiaryBankAccountsHeaders,
            path: zListBeneficiaryBankAccountsPath,
            query: zListBeneficiaryBankAccountsQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listBeneficiaryBankAccountsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/beneficiaries/{id}/bank-accounts',
      ...options,
    });
  }

  /**
   * Create a beneficiary bank account
   *
   * Creates a new bank account for an existing beneficiary. The beneficiary must belong to the authenticated user's client. Bank account details such as IBAN or account number with routing codes must be provided.
   */
  public createBeneficiaryBankAccount<ThrowOnError extends boolean = false>(
    options: Options<CreateBeneficiaryBankAccountData, ThrowOnError>,
  ): RequestResult<
    CreateBeneficiaryBankAccountResponses,
    CreateBeneficiaryBankAccountErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      CreateBeneficiaryBankAccountResponses,
      CreateBeneficiaryBankAccountErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zCreateBeneficiaryBankAccountBody,
            headers: zCreateBeneficiaryBankAccountHeaders,
            path: zCreateBeneficiaryBankAccountPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await createBeneficiaryBankAccountResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/beneficiaries/{id}/bank-accounts',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Update beneficiary details
   *
   * Updates a beneficiary's identity (name) and/or address. Bank account details such as IBAN are managed via the bank account update endpoint. The beneficiary type (individual/corporate) is immutable. Users can only update beneficiaries associated with their own client.
   */
  public updateBeneficiaryDetails<ThrowOnError extends boolean = false>(
    options: Options<UpdateBeneficiaryDetailsData, ThrowOnError>,
  ): RequestResult<
    UpdateBeneficiaryDetailsResponses,
    UpdateBeneficiaryDetailsErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      UpdateBeneficiaryDetailsResponses,
      UpdateBeneficiaryDetailsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zUpdateBeneficiaryDetailsBody,
            headers: zUpdateBeneficiaryDetailsHeaders,
            path: zUpdateBeneficiaryDetailsPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await updateBeneficiaryDetailsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/beneficiaries/{id}/actions/update-details',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Delete a beneficiary
   *
   * Soft delete. The beneficiary is hidden from the beneficiary list and can no longer be paid or edited. Integrated Finance remains the system of record and exposes no delete operation, so the upstream beneficiary and its bank accounts are left untouched — which is what keeps historical transfers resolving. Its bank accounts are deleted with it (same soft delete); its documents stay readable. Users can only delete beneficiaries associated with their own client. No liveness check applies: the record stays in our database and nothing leaves for Integrated Finance.
   */
  public deleteBeneficiary<ThrowOnError extends boolean = false>(
    options: Options<DeleteBeneficiaryData, ThrowOnError>,
  ): RequestResult<DeleteBeneficiaryResponses, DeleteBeneficiaryErrors, ThrowOnError> {
    return (options.client ?? this.client).delete<
      DeleteBeneficiaryResponses,
      DeleteBeneficiaryErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zDeleteBeneficiaryHeaders,
            path: zDeleteBeneficiaryPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseValidator: async (data) => await deleteBeneficiaryResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/beneficiaries/{id}',
      ...options,
    });
  }

  /**
   * Update a beneficiary bank account
   *
   * Updates one of a beneficiary's bank accounts (IBAN, routing codes, currency, country, account holder type). Only the provided fields are changed; unspecified fields are preserved. The beneficiary must belong to the authenticated user's client.
   */
  public updateBeneficiaryBankAccount<ThrowOnError extends boolean = false>(
    options: Options<UpdateBeneficiaryBankAccountData, ThrowOnError>,
  ): RequestResult<
    UpdateBeneficiaryBankAccountResponses,
    UpdateBeneficiaryBankAccountErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      UpdateBeneficiaryBankAccountResponses,
      UpdateBeneficiaryBankAccountErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zUpdateBeneficiaryBankAccountBody,
            headers: zUpdateBeneficiaryBankAccountHeaders,
            path: zUpdateBeneficiaryBankAccountPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await updateBeneficiaryBankAccountResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/beneficiaries/{id}/bank-accounts/{bankAccountId}/actions/update',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Delete a beneficiary bank account
   *
   * Soft delete. The bank account disappears from the bank account list and can no longer be paid or edited. Integrated Finance exposes no delete for bank accounts, so the upstream record is left untouched, which keeps historical transfers resolving. Deleting the last account of a beneficiary is allowed. Users can only delete bank accounts of beneficiaries associated with their own client. No liveness check applies: the record stays in our database and nothing leaves for Integrated Finance.
   */
  public deleteBeneficiaryBankAccount<ThrowOnError extends boolean = false>(
    options: Options<DeleteBeneficiaryBankAccountData, ThrowOnError>,
  ): RequestResult<
    DeleteBeneficiaryBankAccountResponses,
    DeleteBeneficiaryBankAccountErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).delete<
      DeleteBeneficiaryBankAccountResponses,
      DeleteBeneficiaryBankAccountErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zDeleteBeneficiaryBankAccountHeaders,
            path: zDeleteBeneficiaryBankAccountPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseValidator: async (data) =>
        await deleteBeneficiaryBankAccountResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/beneficiaries/{id}/bank-accounts/{bankAccountId}',
      ...options,
    });
  }

  /**
   * List documents
   *
   * Retrieves a list of documents for a specific entity. Each document includes a signed URL for download.
   */
  public listDocuments<ThrowOnError extends boolean = false>(
    options: Options<ListDocumentsData, ThrowOnError>,
  ): RequestResult<ListDocumentsResponses, ListDocumentsErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      ListDocumentsResponses,
      ListDocumentsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListDocumentsHeaders,
            path: zListDocumentsPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listDocumentsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/documents/{entity}/{id}',
      ...options,
    });
  }

  /**
   * Get upload URL
   *
   * Generates a presigned POST URL for uploading a document. The client should POST the file directly to S3 as multipart/form-data, including all returned fields. The Content-Type header must match the file extension.
   */
  public getDocumentUploadUrl<ThrowOnError extends boolean = false>(
    options: Options<GetDocumentUploadUrlData, ThrowOnError>,
  ): RequestResult<GetDocumentUploadUrlResponses, GetDocumentUploadUrlErrors, ThrowOnError> {
    return (options.client ?? this.client).put<
      GetDocumentUploadUrlResponses,
      GetDocumentUploadUrlErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetDocumentUploadUrlHeaders,
            path: zGetDocumentUploadUrlPath,
            query: zGetDocumentUploadUrlQuery,
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getDocumentUploadUrlResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/documents/{entity}/{id}',
      ...options,
    });
  }

  /**
   * Delete document
   *
   * Deletes a document from storage. The document name should be URL-encoded if it contains special characters.
   */
  public deleteDocument<ThrowOnError extends boolean = false>(
    options: Options<DeleteDocumentData, ThrowOnError>,
  ): RequestResult<unknown, DeleteDocumentErrors, ThrowOnError> {
    return (options.client ?? this.client).delete<unknown, DeleteDocumentErrors, ThrowOnError>({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zDeleteDocumentHeaders,
            path: zDeleteDocumentPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/documents/{entity}/{id}/{documentName}',
      ...options,
    });
  }

  /**
   * Get challenge status
   *
   * Retrieves the current status of a challenge by polling the CIBA authorization.
   */
  public getChallengeStatus<ThrowOnError extends boolean = false>(
    options: Options<GetChallengeStatusData, ThrowOnError>,
  ): RequestResult<GetChallengeStatusResponses, GetChallengeStatusErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetChallengeStatusResponses,
      GetChallengeStatusErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetChallengeStatusHeaders,
            path: zGetChallengeStatusPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getChallengeStatusResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/challenges/{id}',
      ...options,
    });
  }

  /**
   * Initiate an email change challenge
   *
   * Generates a 6-digit OTP and sends it to the new email address.
   */
  public initiateEmailChangeChallenge<ThrowOnError extends boolean = false>(
    options: Options<InitiateEmailChangeChallengeData, ThrowOnError>,
  ): RequestResult<unknown, InitiateEmailChangeChallengeErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      unknown,
      InitiateEmailChangeChallengeErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zInitiateEmailChangeChallengeBody,
            headers: zInitiateEmailChangeChallengeHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/challenges/email-change',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Verify email change challenge OTP
   *
   * Validates the OTP, revokes all Auth0 sessions (and their refresh tokens), updates the Auth0 email, and notifies the old email address.
   */
  public verifyEmailChangeChallenge<ThrowOnError extends boolean = false>(
    options: Options<VerifyEmailChangeChallengeData, ThrowOnError>,
  ): RequestResult<unknown, VerifyEmailChangeChallengeErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      unknown,
      VerifyEmailChangeChallengeErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zVerifyEmailChangeChallengeBody,
            headers: zVerifyEmailChangeChallengeHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/challenges/email-change/verify',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Resend the email verification message
   *
   * Asks Auth0 to dispatch a new verification email to the authenticated user. Rejected if the user has already verified their email.
   */
  public resendEmailChallenge<ThrowOnError extends boolean = false>(
    options: Options<ResendEmailChallengeData, ThrowOnError>,
  ): RequestResult<ResendEmailChallengeResponses, ResendEmailChallengeErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      ResendEmailChallengeResponses,
      ResendEmailChallengeErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zResendEmailChallengeHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await resendEmailChallengeResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/challenges/email/resend',
      ...options,
    });
  }

  /**
   * Start a liveness challenge
   *
   * Creates a Sumsub liveness action and returns a hosted WebSDK URL for the client.
   */
  public startLivenessChallenge<ThrowOnError extends boolean = false>(
    options: Options<StartLivenessChallengeData, ThrowOnError>,
  ): RequestResult<StartLivenessChallengeResponses, StartLivenessChallengeErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      StartLivenessChallengeResponses,
      StartLivenessChallengeErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zStartLivenessChallengeBody,
            headers: zStartLivenessChallengeHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await startLivenessChallengeResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/challenges/actions/start-liveness',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get liveness challenge status
   *
   * Retrieves the current status of a liveness challenge.
   */
  public getLivenessChallengeStatus<ThrowOnError extends boolean = false>(
    options: Options<GetLivenessChallengeStatusData, ThrowOnError>,
  ): RequestResult<
    GetLivenessChallengeStatusResponses,
    GetLivenessChallengeStatusErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).get<
      GetLivenessChallengeStatusResponses,
      GetLivenessChallengeStatusErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetLivenessChallengeStatusHeaders,
            path: zGetLivenessChallengeStatusPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getLivenessChallengeStatusResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/challenges/liveness/{id}',
      ...options,
    });
  }

  /**
   * Initiate a phone number verification challenge
   *
   * Sends an OTP to the provided phone number and returns a challenge reference. The phone number is NOT enrolled as an MFA factor — it is collected as a verified profile attribute.
   */
  public initiatePhoneChallenge<ThrowOnError extends boolean = false>(
    options: Options<InitiatePhoneChallengeData, ThrowOnError>,
  ): RequestResult<InitiatePhoneChallengeResponses, InitiatePhoneChallengeErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      InitiatePhoneChallengeResponses,
      InitiatePhoneChallengeErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zInitiatePhoneChallengeBody,
            headers: zInitiatePhoneChallengeHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await initiatePhoneChallengeResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/challenges/phone',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Verify OTP and persist the phone number
   *
   * Validates the OTP code and, on success, sets phone_number and phone_verified=true on the Auth0 user profile. Also syncs the phone number to Novu, Sumsub, and HubSpot.
   */
  public verifyPhoneChallenge<ThrowOnError extends boolean = false>(
    options: Options<VerifyPhoneChallengeData, ThrowOnError>,
  ): RequestResult<VerifyPhoneChallengeResponses, VerifyPhoneChallengeErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      VerifyPhoneChallengeResponses,
      VerifyPhoneChallengeErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zVerifyPhoneChallengeBody,
            headers: zVerifyPhoneChallengeHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await verifyPhoneChallengeResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/challenges/phone/verify',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get client
   *
   * Retrieves client details for the authenticated user. The requested client ID must match the authenticated client.
   */
  public getClient<ThrowOnError extends boolean = false>(
    options: Options<GetClientData, ThrowOnError>,
  ): RequestResult<GetClientResponses, GetClientErrors, ThrowOnError> {
    return (options.client ?? this.client).get<GetClientResponses, GetClientErrors, ThrowOnError>({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetClientHeaders,
            path: zGetClientPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getClientResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/clients/{id}',
      ...options,
    });
  }

  /**
   * List client relations
   *
   * Retrieves a paginated list of relations for the authenticated client. The requested client ID must match the authenticated client.
   */
  public listClientRelations<ThrowOnError extends boolean = false>(
    options: Options<ListClientRelationsData, ThrowOnError>,
  ): RequestResult<ListClientRelationsResponses, ListClientRelationsErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      ListClientRelationsResponses,
      ListClientRelationsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListClientRelationsHeaders,
            path: zListClientRelationsPath,
            query: zListClientRelationsQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listClientRelationsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/clients/{id}/relations',
      ...options,
    });
  }

  /**
   * Create exchange quote
   */
  public createExchangeQuote<ThrowOnError extends boolean = false>(
    options: Options<CreateExchangeQuoteData, ThrowOnError>,
  ): RequestResult<CreateExchangeQuoteResponses, CreateExchangeQuoteErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      CreateExchangeQuoteResponses,
      CreateExchangeQuoteErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zCreateExchangeQuoteBody,
            headers: zCreateExchangeQuoteHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await createExchangeQuoteResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/exchanges/quotes',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Refresh exchange quote
   */
  public refreshExchangeQuote<ThrowOnError extends boolean = false>(
    options: Options<RefreshExchangeQuoteData, ThrowOnError>,
  ): RequestResult<RefreshExchangeQuoteResponses, RefreshExchangeQuoteErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      RefreshExchangeQuoteResponses,
      RefreshExchangeQuoteErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zRefreshExchangeQuoteBody,
            headers: zRefreshExchangeQuoteHeaders,
            path: zRefreshExchangeQuotePath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await refreshExchangeQuoteResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/exchanges/quotes/{id}/refresh',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Create exchange transaction
   */
  public createExchangeTransaction<ThrowOnError extends boolean = false>(
    options: Options<CreateExchangeTransactionData, ThrowOnError>,
  ): RequestResult<
    CreateExchangeTransactionResponses,
    CreateExchangeTransactionErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      CreateExchangeTransactionResponses,
      CreateExchangeTransactionErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zCreateExchangeTransactionBody,
            headers: zCreateExchangeTransactionHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await createExchangeTransactionResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/exchanges/transactions',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get exchange transaction
   */
  public getExchangeTransaction<ThrowOnError extends boolean = false>(
    options: Options<GetExchangeTransactionData, ThrowOnError>,
  ): RequestResult<GetExchangeTransactionResponses, GetExchangeTransactionErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetExchangeTransactionResponses,
      GetExchangeTransactionErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetExchangeTransactionHeaders,
            path: zGetExchangeTransactionPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getExchangeTransactionResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/exchanges/transactions/{id}',
      ...options,
    });
  }

  /**
   * List generic transactions
   *
   * Retrieves a paginated list of generic transactions for the authenticated user's client. Supports filtering by account, type, transaction number, and creation date range. Users can only access generic transactions associated with their own client.
   */
  public listGenericTransactions<ThrowOnError extends boolean = false>(
    options: Options<ListGenericTransactionsData, ThrowOnError>,
  ): RequestResult<ListGenericTransactionsResponses, ListGenericTransactionsErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      ListGenericTransactionsResponses,
      ListGenericTransactionsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListGenericTransactionsHeaders,
            path: z.never().optional(),
            query: zListGenericTransactionsQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listGenericTransactionsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/generic',
      ...options,
    });
  }

  /**
   * Get generic transaction by ID
   *
   * Retrieves details of a specific generic transaction by its ID. Users can only access generic transactions associated with their own client.
   */
  public getGenericTransactionById<ThrowOnError extends boolean = false>(
    options: Options<GetGenericTransactionByIdData, ThrowOnError>,
  ): RequestResult<
    GetGenericTransactionByIdResponses,
    GetGenericTransactionByIdErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).get<
      GetGenericTransactionByIdResponses,
      GetGenericTransactionByIdErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetGenericTransactionByIdHeaders,
            path: zGetGenericTransactionByIdPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getGenericTransactionByIdResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/generic/{id}',
      ...options,
    });
  }

  /**
   * Export generic transaction confirmation
   *
   * Generates a generic transaction confirmation export. The confirmation reuses the incoming or outgoing transfer layout depending on the transaction type. For now, only PDF exports are supported via Accept: application/pdf.
   */
  public exportGenericTransactionConfirmation<ThrowOnError extends boolean = false>(
    options: Options<ExportGenericTransactionConfirmationData, ThrowOnError>,
  ): RequestResult<
    ExportGenericTransactionConfirmationResponses,
    ExportGenericTransactionConfirmationErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      ExportGenericTransactionConfirmationResponses,
      ExportGenericTransactionConfirmationErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zExportGenericTransactionConfirmationHeaders,
            path: zExportGenericTransactionConfirmationPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'blob',
      responseValidator: async (data) =>
        await exportGenericTransactionConfirmationResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/generic/{id}/actions/export',
      ...options,
    });
  }

  /**
   * List incoming transfers
   *
   * Retrieves a paginated list of incoming transfers for the authenticated user's client. Supports filtering by status, transaction number, sender name, and transfer date range. Users can only access incoming transfers associated with their own client.
   */
  public listIncomingTransfers<ThrowOnError extends boolean = false>(
    options: Options<ListIncomingTransfersData, ThrowOnError>,
  ): RequestResult<ListIncomingTransfersResponses, ListIncomingTransfersErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      ListIncomingTransfersResponses,
      ListIncomingTransfersErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListIncomingTransfersHeaders,
            path: z.never().optional(),
            query: zListIncomingTransfersQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listIncomingTransfersResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/incoming',
      ...options,
    });
  }

  /**
   * Get incoming transfer by ID
   *
   * Retrieves details of a specific incoming transfer by its ID. Users can only access incoming transfers associated with their own client.
   */
  public getIncomingTransferById<ThrowOnError extends boolean = false>(
    options: Options<GetIncomingTransferByIdData, ThrowOnError>,
  ): RequestResult<GetIncomingTransferByIdResponses, GetIncomingTransferByIdErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetIncomingTransferByIdResponses,
      GetIncomingTransferByIdErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetIncomingTransferByIdHeaders,
            path: zGetIncomingTransferByIdPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getIncomingTransferByIdResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/incoming/{id}',
      ...options,
    });
  }

  /**
   * Export incoming transfer confirmation
   *
   * Generates an incoming transfer confirmation export. For now, only PDF exports are supported via Accept: application/pdf.
   */
  public exportIncomingTransferConfirmation<ThrowOnError extends boolean = false>(
    options: Options<ExportIncomingTransferConfirmationData, ThrowOnError>,
  ): RequestResult<
    ExportIncomingTransferConfirmationResponses,
    ExportIncomingTransferConfirmationErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      ExportIncomingTransferConfirmationResponses,
      ExportIncomingTransferConfirmationErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zExportIncomingTransferConfirmationHeaders,
            path: zExportIncomingTransferConfirmationPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'blob',
      responseValidator: async (data) =>
        await exportIncomingTransferConfirmationResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/incoming/{id}/actions/export',
      ...options,
    });
  }

  /**
   * Get Guardian MFA status
   *
   * Retrieves the Guardian MFA enrollment status for the authenticated user. Returns connection status, device name, enrollment date, and last usage date.
   */
  public getGuardianStatus<ThrowOnError extends boolean = false>(
    options: Options<GetGuardianStatusData, ThrowOnError>,
  ): RequestResult<GetGuardianStatusResponses, GetGuardianStatusErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetGuardianStatusResponses,
      GetGuardianStatusErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetGuardianStatusHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getGuardianStatusResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/users/mfa/guardian',
      ...options,
    });
  }

  /**
   * Get Novu bootstrap configuration
   *
   * Returns configuration needed for frontend Novu integration including application identifier, subscriber ID, HMAC hash, and API/socket URLs
   */
  public getNovuBootstrapInfo<ThrowOnError extends boolean = false>(
    options: Options<GetNovuBootstrapInfoData, ThrowOnError>,
  ): RequestResult<GetNovuBootstrapInfoResponses, GetNovuBootstrapInfoErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetNovuBootstrapInfoResponses,
      GetNovuBootstrapInfoErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetNovuBootstrapInfoHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getNovuBootstrapInfoResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/novu/bootstrap',
      ...options,
    });
  }

  /**
   * Identify or update subscriber in Novu
   *
   * Creates or updates a subscriber in Novu. Call this on first login or when user profile is updated.
   */
  public identifyNovuSubscriber<ThrowOnError extends boolean = false>(
    options: Options<IdentifyNovuSubscriberData, ThrowOnError>,
  ): RequestResult<IdentifyNovuSubscriberResponses, IdentifyNovuSubscriberErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      IdentifyNovuSubscriberResponses,
      IdentifyNovuSubscriberErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zIdentifyNovuSubscriberBody,
            headers: zIdentifyNovuSubscriberHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await identifyNovuSubscriberResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/novu/identify',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get subscriber notification preferences
   *
   * Retrieves notification channel preferences (email, SMS, in-app, push, chat) for all workflows and global preferences for the authenticated user
   */
  public getNotificationPreferences<ThrowOnError extends boolean = false>(
    options: Options<GetNotificationPreferencesData, ThrowOnError>,
  ): RequestResult<
    GetNotificationPreferencesResponses,
    GetNotificationPreferencesErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).get<
      GetNotificationPreferencesResponses,
      GetNotificationPreferencesErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetNotificationPreferencesHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getNotificationPreferencesResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/novu/preferences',
      ...options,
    });
  }

  /**
   * Update subscriber notification preferences
   *
   * Updates notification channel preferences for a specific workflow or globally. Allows users to enable/disable channels (email, SMS, in-app, push, chat) and set delivery schedules.
   */
  public updateNotificationPreferences<ThrowOnError extends boolean = false>(
    options: Options<UpdateNotificationPreferencesData, ThrowOnError>,
  ): RequestResult<
    UpdateNotificationPreferencesResponses,
    UpdateNotificationPreferencesErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      UpdateNotificationPreferencesResponses,
      UpdateNotificationPreferencesErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zUpdateNotificationPreferencesBody,
            headers: zUpdateNotificationPreferencesHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/novu/preferences',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Remove Expo Push notification device token
   *
   * Removes a specific Expo Push device token for the authenticated user. Call this when the user logs out to prevent push notifications from being sent to logged-out devices.
   */
  public removeDeviceToken<ThrowOnError extends boolean = false>(
    options: Options<RemoveDeviceTokenData, ThrowOnError>,
  ): RequestResult<RemoveDeviceTokenResponses, RemoveDeviceTokenErrors, ThrowOnError> {
    return (options.client ?? this.client).delete<
      RemoveDeviceTokenResponses,
      RemoveDeviceTokenErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zRemoveDeviceTokenBody,
            headers: zRemoveDeviceTokenHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/novu/device-token',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Set Expo Push notification device token
   *
   * Updates the subscriber credentials for Expo Push notifications with the provided device token. The device token is associated with the authenticated user.
   */
  public setDeviceToken<ThrowOnError extends boolean = false>(
    options: Options<SetDeviceTokenData, ThrowOnError>,
  ): RequestResult<SetDeviceTokenResponses, SetDeviceTokenErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      SetDeviceTokenResponses,
      SetDeviceTokenErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zSetDeviceTokenBody,
            headers: zSetDeviceTokenHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/novu/device-token',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Trigger a notification (Local environment only)
   *
   * Manually trigger a notification workflow. This endpoint is only available in local environment for testing purposes.
   */
  public triggerNotification<ThrowOnError extends boolean = false>(
    options: Options<TriggerNotificationData, ThrowOnError>,
  ): RequestResult<TriggerNotificationResponses, TriggerNotificationErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      TriggerNotificationResponses,
      TriggerNotificationErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zTriggerNotificationBody,
            headers: zTriggerNotificationHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await triggerNotificationResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/novu/trigger',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Create organization
   *
   * Creates a new organization, adds the authenticated user as a member, and enables the database connection.
   */
  public createOrganization<ThrowOnError extends boolean = false>(
    options: Options<CreateOrganizationData, ThrowOnError>,
  ): RequestResult<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      CreateOrganizationResponses,
      CreateOrganizationErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zCreateOrganizationBody,
            headers: zCreateOrganizationHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await createOrganizationResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/organizations',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * List organization members
   *
   * Lists the members of the active organization, enriched with each member’s per-org onboarding status.
   */
  public listOrganizationMembers<ThrowOnError extends boolean = false>(
    options: Options<ListOrganizationMembersData, ThrowOnError>,
  ): RequestResult<ListOrganizationMembersResponses, ListOrganizationMembersErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      ListOrganizationMembersResponses,
      ListOrganizationMembersErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListOrganizationMembersHeaders,
            path: zListOrganizationMembersPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listOrganizationMembersResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/organizations/{organizationId}/members',
      ...options,
    });
  }

  /**
   * Deactivate an organization member
   *
   * Removes a member from the active organization and revokes their sessions. The member keeps access to their other organizations. Restricted to the organization creator, who in turn cannot be removed.
   */
  public deactivateOrganizationMember<ThrowOnError extends boolean = false>(
    options: Options<DeactivateOrganizationMemberData, ThrowOnError>,
  ): RequestResult<
    DeactivateOrganizationMemberResponses,
    DeactivateOrganizationMemberErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).delete<
      DeactivateOrganizationMemberResponses,
      DeactivateOrganizationMemberErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zDeactivateOrganizationMemberHeaders,
            path: zDeactivateOrganizationMemberPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseValidator: async (data) =>
        await deactivateOrganizationMemberResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/organizations/{organizationId}/members/{userId}',
      ...options,
    });
  }

  /**
   * Invite a member
   *
   * Invites a person by email to the active organization. The invitee completes individual onboarding (KYC/liveness) on acceptance before gaining access.
   */
  public inviteOrganizationMember<ThrowOnError extends boolean = false>(
    options: Options<InviteOrganizationMemberData, ThrowOnError>,
  ): RequestResult<
    InviteOrganizationMemberResponses,
    InviteOrganizationMemberErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      InviteOrganizationMemberResponses,
      InviteOrganizationMemberErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zInviteOrganizationMemberBody,
            headers: zInviteOrganizationMemberHeaders,
            path: zInviteOrganizationMemberPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await inviteOrganizationMemberResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/organizations/{organizationId}/invitations',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Revoke an invitation
   *
   * Revokes a pending invitation (idempotent if already revoked).
   */
  public revokeOrganizationInvitation<ThrowOnError extends boolean = false>(
    options: Options<RevokeOrganizationInvitationData, ThrowOnError>,
  ): RequestResult<
    RevokeOrganizationInvitationResponses,
    RevokeOrganizationInvitationErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).delete<
      RevokeOrganizationInvitationResponses,
      RevokeOrganizationInvitationErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zRevokeOrganizationInvitationHeaders,
            path: zRevokeOrganizationInvitationPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseValidator: async (data) =>
        await revokeOrganizationInvitationResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/organizations/{organizationId}/invitations/{invitationId}',
      ...options,
    });
  }

  /**
   * Resend an invitation
   *
   * Issues a fresh invitation and emails it. Auth0 has no resend API, so the previously sent link STOPS WORKING and the expiry resets. Works on expired invitations too, so this doubles as "invite again".
   */
  public resendOrganizationInvitation<ThrowOnError extends boolean = false>(
    options: Options<ResendOrganizationInvitationData, ThrowOnError>,
  ): RequestResult<
    ResendOrganizationInvitationResponses,
    ResendOrganizationInvitationErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      ResendOrganizationInvitationResponses,
      ResendOrganizationInvitationErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zResendOrganizationInvitationHeaders,
            path: zResendOrganizationInvitationPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseValidator: async (data) =>
        await resendOrganizationInvitationResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/organizations/{organizationId}/invitations/{invitationId}/resend',
      ...options,
    });
  }

  /**
   * List reports
   *
   * Newest first, offset-paginated. Returns only the authenticated client's reports. Download URLs are deliberately absent — request one per download.
   */
  public listReports<ThrowOnError extends boolean = false>(
    options: Options<ListReportsData, ThrowOnError>,
  ): RequestResult<ListReportsResponses, ListReportsErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      ListReportsResponses,
      ListReportsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListReportsHeaders,
            path: z.never().optional(),
            query: zListReportsQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listReportsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/reports',
      ...options,
    });
  }

  /**
   * Generate a report
   *
   * Starts generation and returns immediately with a PENDING report; the result arrives over WebSocket (refetch key REPORTS). Returns 200 with an existing COMPLETED report instead when one already covers the request and the period it covers had settled by the time it was generated.
   */
  public createReport<ThrowOnError extends boolean = false>(
    options: Options<CreateReportData, ThrowOnError>,
  ): RequestResult<CreateReportResponses, CreateReportErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      CreateReportResponses,
      CreateReportErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zCreateReportBody,
            headers: zCreateReportHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await createReportResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/reports',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get a report download link
   *
   * Returns a short-lived presigned S3 URL. Navigate to it (location.href) rather than fetching it: the URL carries a signed content-disposition, so the browser downloads the file without unloading the page and without CORS. Mint it on click — a stale URL renders an S3 error page instead.
   */
  public getReportDownloadUrl<ThrowOnError extends boolean = false>(
    options: Options<GetReportDownloadUrlData, ThrowOnError>,
  ): RequestResult<GetReportDownloadUrlResponses, GetReportDownloadUrlErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetReportDownloadUrlResponses,
      GetReportDownloadUrlErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetReportDownloadUrlHeaders,
            path: zGetReportDownloadUrlPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getReportDownloadUrlResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/reports/{id}/download',
      ...options,
    });
  }

  /**
   * Receive and process an Inventi webhook
   *
   * Receives an Inventi Payments Gateway webhook and acknowledges it. Payload → domain-event mapping is implemented in feature phases.
   */
  public receiveInventiWebhook<ThrowOnError extends boolean = false>(
    options: Options<ReceiveInventiWebhookData, ThrowOnError>,
  ): RequestResult<ReceiveInventiWebhookResponses, ReceiveInventiWebhookErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      ReceiveInventiWebhookResponses,
      ReceiveInventiWebhookErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zReceiveInventiWebhookBody,
            headers: zReceiveInventiWebhookHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await receiveInventiWebhookResponse.parseAsync(data),
      url: '/v1/webhooks/inventi',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Receive an Inventi liquidity low-balance alert
   *
   * Receives an Inventi low-balance webhook and notifies the internal treasury topic by email.
   */
  public receiveInventiLiquidityWebhook<ThrowOnError extends boolean = false>(
    options: Options<ReceiveInventiLiquidityWebhookData, ThrowOnError>,
  ): RequestResult<
    ReceiveInventiLiquidityWebhookResponses,
    ReceiveInventiLiquidityWebhookErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      ReceiveInventiLiquidityWebhookResponses,
      ReceiveInventiLiquidityWebhookErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zReceiveInventiLiquidityWebhookBody,
            headers: zReceiveInventiLiquidityWebhookHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await receiveInventiLiquidityWebhookResponse.parseAsync(data),
      url: '/v1/webhooks/inventi/liquidity',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get outgoing transfer limits
   *
   * Retrieves configured outgoing transfer limits for the authenticated client, plus today's usage and remaining allowance on the daily window. Pass `accountId` to fold in that account's own limits; each returned limit reports the scope that binds it.
   */
  public getOutgoingTransferLimits<ThrowOnError extends boolean = false>(
    options: Options<GetOutgoingTransferLimitsData, ThrowOnError>,
  ): RequestResult<
    GetOutgoingTransferLimitsResponses,
    GetOutgoingTransferLimitsErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).get<
      GetOutgoingTransferLimitsResponses,
      GetOutgoingTransferLimitsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetOutgoingTransferLimitsHeaders,
            path: z.never().optional(),
            query: zGetOutgoingTransferLimitsQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getOutgoingTransferLimitsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/limits',
      ...options,
    });
  }

  /**
   * Set outgoing transfer limits
   *
   * Initiates a CIBA challenge to set per-transfer and daily limits for outgoing transfers.
   */
  public setTransferLimits<ThrowOnError extends boolean = false>(
    options: Options<SetTransferLimitsData, ThrowOnError>,
  ): RequestResult<SetTransferLimitsResponses, SetTransferLimitsErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      SetTransferLimitsResponses,
      SetTransferLimitsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zSetTransferLimitsBody,
            headers: zSetTransferLimitsHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await setTransferLimitsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/actions/set-transfer-limits',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * List outgoing transfers
   *
   * Retrieves a paginated list of outgoing transfers for the authenticated user's client.
   */
  public listOutgoingTransfers<ThrowOnError extends boolean = false>(
    options: Options<ListOutgoingTransfersData, ThrowOnError>,
  ): RequestResult<ListOutgoingTransfersResponses, ListOutgoingTransfersErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      ListOutgoingTransfersResponses,
      ListOutgoingTransfersErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListOutgoingTransfersHeaders,
            path: z.never().optional(),
            query: zListOutgoingTransfersQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listOutgoingTransfersResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing',
      ...options,
    });
  }

  /**
   * List transfer reasons
   *
   * Retrieves available transfer reasons for a specific account and country.
   */
  public listTransferReasons<ThrowOnError extends boolean = false>(
    options: Options<ListTransferReasonsData, ThrowOnError>,
  ): RequestResult<ListTransferReasonsResponses, ListTransferReasonsErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      ListTransferReasonsResponses,
      ListTransferReasonsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListTransferReasonsHeaders,
            path: z.never().optional(),
            query: zListTransferReasonsQuery,
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listTransferReasonsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/reasons',
      ...options,
    });
  }

  /**
   * List transfer reasons common to several countries
   *
   * Retrieves the transfer reasons available for a specific account in every one of the given countries — e.g. all destination countries of an outgoing payment batch.
   */
  public listCommonTransferReasons<ThrowOnError extends boolean = false>(
    options: Options<ListCommonTransferReasonsData, ThrowOnError>,
  ): RequestResult<
    ListCommonTransferReasonsResponses,
    ListCommonTransferReasonsErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).get<
      ListCommonTransferReasonsResponses,
      ListCommonTransferReasonsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListCommonTransferReasonsHeaders,
            path: z.never().optional(),
            query: zListCommonTransferReasonsQuery,
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listCommonTransferReasonsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/reasons/common',
      ...options,
    });
  }

  /**
   * Get transfer date metadata
   *
   * Retrieves available transfer dates and cutoff information for a specific account and scheme.
   */
  public getTransferDateMetadata<ThrowOnError extends boolean = false>(
    options: Options<GetTransferDateMetadataData, ThrowOnError>,
  ): RequestResult<GetTransferDateMetadataResponses, GetTransferDateMetadataErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetTransferDateMetadataResponses,
      GetTransferDateMetadataErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetTransferDateMetadataHeaders,
            path: z.never().optional(),
            query: zGetTransferDateMetadataQuery,
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getTransferDateMetadataResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/date-metadata',
      ...options,
    });
  }

  /**
   * Reachable transfer schemes for a beneficiary
   */
  public getReachableTransferSchemes<ThrowOnError extends boolean = false>(
    options: Options<GetReachableTransferSchemesData, ThrowOnError>,
  ): RequestResult<
    GetReachableTransferSchemesResponses,
    GetReachableTransferSchemesErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).get<
      GetReachableTransferSchemesResponses,
      GetReachableTransferSchemesErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetReachableTransferSchemesHeaders,
            path: z.never().optional(),
            query: zGetReachableTransferSchemesQuery,
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getReachableTransferSchemesResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/schemes',
      ...options,
    });
  }

  /**
   * Get outgoing transfer by ID
   *
   * Retrieves details of a specific outgoing transfer by its ID.
   */
  public getOutgoingTransferById<ThrowOnError extends boolean = false>(
    options: Options<GetOutgoingTransferByIdData, ThrowOnError>,
  ): RequestResult<GetOutgoingTransferByIdResponses, GetOutgoingTransferByIdErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetOutgoingTransferByIdResponses,
      GetOutgoingTransferByIdErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetOutgoingTransferByIdHeaders,
            path: zGetOutgoingTransferByIdPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getOutgoingTransferByIdResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/{id}',
      ...options,
    });
  }

  /**
   * Export outgoing transfer confirmation
   *
   * Generates an outgoing transfer confirmation export. For now, only PDF exports are supported via Accept: application/pdf.
   */
  public exportOutgoingTransferConfirmation<ThrowOnError extends boolean = false>(
    options: Options<ExportOutgoingTransferConfirmationData, ThrowOnError>,
  ): RequestResult<
    ExportOutgoingTransferConfirmationResponses,
    ExportOutgoingTransferConfirmationErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      ExportOutgoingTransferConfirmationResponses,
      ExportOutgoingTransferConfirmationErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zExportOutgoingTransferConfirmationHeaders,
            path: zExportOutgoingTransferConfirmationPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'blob',
      responseValidator: async (data) =>
        await exportOutgoingTransferConfirmationResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/{id}/actions/export',
      ...options,
    });
  }

  /**
   * Create internal transfer
   *
   * Initiates a new internal transfer between accounts. Returns a CIBA challenge for user authorization when transferring to a different client, or executes directly for same-client transfers. For cross-client transfers: if the same Idempotency-Key is sent multiple times, each request creates a new challenge, but only one transfer will be executed by the downstream provider regardless of how many challenges are approved.
   */
  public createInternalTransfer<ThrowOnError extends boolean = false>(
    options: Options<CreateInternalTransferData, ThrowOnError>,
  ): RequestResult<CreateInternalTransferResponses, CreateInternalTransferErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      CreateInternalTransferResponses,
      CreateInternalTransferErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zCreateInternalTransferBody,
            headers: zCreateInternalTransferHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await createInternalTransferResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/internal',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Create external transfer
   *
   * Initiates a new external transfer to a beneficiary. Returns a CIBA challenge for user authorization, or executes directly when the beneficiary is another of the client's own accounts. If the same Idempotency-Key is sent multiple times, each request creates a new challenge, but only one transfer will be executed by the downstream provider regardless of how many challenges are approved.
   */
  public createExternalTransfer<ThrowOnError extends boolean = false>(
    options: Options<CreateExternalTransferData, ThrowOnError>,
  ): RequestResult<CreateExternalTransferResponses, CreateExternalTransferErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      CreateExternalTransferResponses,
      CreateExternalTransferErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zCreateExternalTransferBody,
            headers: zCreateExternalTransferHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await createExternalTransferResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/external',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Dry run internal transfer
   *
   * Validates an internal transfer without executing it.
   */
  public dryRunInternalTransfer<ThrowOnError extends boolean = false>(
    options: Options<DryRunInternalTransferData, ThrowOnError>,
  ): RequestResult<DryRunInternalTransferResponses, DryRunInternalTransferErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      DryRunInternalTransferResponses,
      DryRunInternalTransferErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zDryRunInternalTransferBody,
            headers: zDryRunInternalTransferHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await dryRunInternalTransferResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/internal/dry-run',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Dry run external transfer
   *
   * Validates an external transfer without executing it.
   */
  public dryRunExternalTransfer<ThrowOnError extends boolean = false>(
    options: Options<DryRunExternalTransferData, ThrowOnError>,
  ): RequestResult<DryRunExternalTransferResponses, DryRunExternalTransferErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      DryRunExternalTransferResponses,
      DryRunExternalTransferErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zDryRunExternalTransferBody,
            headers: zDryRunExternalTransferHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await dryRunExternalTransferResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/external/dry-run',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Resolve challenge and execute outgoing transfer
   *
   * Resolves a CIBA challenge for an outgoing transfer and executes the transfer synchronously. Only one resolve-challenge request per IF client is processed at a time.
   */
  public resolveOutgoingTransferChallenge<ThrowOnError extends boolean = false>(
    options: Options<ResolveOutgoingTransferChallengeData, ThrowOnError>,
  ): RequestResult<
    ResolveOutgoingTransferChallengeResponses,
    ResolveOutgoingTransferChallengeErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      ResolveOutgoingTransferChallengeResponses,
      ResolveOutgoingTransferChallengeErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zResolveOutgoingTransferChallengeBody,
            headers: zResolveOutgoingTransferChallengeHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await resolveOutgoingTransferChallengeResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/transfers/outgoing/actions/resolve-challenge',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * List payment batches
   *
   * Paginated, always scoped to the caller's client, ordered by creation date descending.
   */
  public listPaymentBatches<ThrowOnError extends boolean = false>(
    options: Options<ListPaymentBatchesData, ThrowOnError>,
  ): RequestResult<ListPaymentBatchesResponses, ListPaymentBatchesErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      ListPaymentBatchesResponses,
      ListPaymentBatchesErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListPaymentBatchesHeaders,
            path: z.never().optional(),
            query: zListPaymentBatchesQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listPaymentBatchesResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches',
      ...options,
    });
  }

  /**
   * Create payment batch
   *
   * Creates an empty batch in `loading`, waiting for exactly `expectedItemCount` rows via POST /:id/items — or directly in `draft` when that count is 0. Verification and submission are refused until the count is reached.
   */
  public createPaymentBatch<ThrowOnError extends boolean = false>(
    options: Options<CreatePaymentBatchData, ThrowOnError>,
  ): RequestResult<CreatePaymentBatchResponses, CreatePaymentBatchErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      CreatePaymentBatchResponses,
      CreatePaymentBatchErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zCreatePaymentBatchBody,
            headers: zCreatePaymentBatchHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await createPaymentBatchResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get cumulative SDD limits for a collection account
   *
   * The account's cumulative collection caps — how many collections it may ever present and how much EUR it may ever collect — and what it has consumed of them. Usage counts every row already presented plus every row a scheduled or executing batch still owes, so these are the figures the submit guard compares a batch against. `remaining` is clamped at zero. Limits are attributes stamped on the account at creation and adjusted out of band; an account missing them answers 422 here, which is how an operator confirms an edit took.
   */
  public getSddAccountLimits<ThrowOnError extends boolean = false>(
    options: Options<GetSddAccountLimitsData, ThrowOnError>,
  ): RequestResult<GetSddAccountLimitsResponses, GetSddAccountLimitsErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetSddAccountLimitsResponses,
      GetSddAccountLimitsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetSddAccountLimitsHeaders,
            path: z.never().optional(),
            query: zGetSddAccountLimitsQuery,
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getSddAccountLimitsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/limits',
      ...options,
    });
  }

  /**
   * Delete payment batch
   *
   * Hard delete, items and all. Allowed while the batch is `loading` or `draft` — a batch being verified, or one that has reached execution, is cancelled instead, never erased.
   */
  public deletePaymentBatch<ThrowOnError extends boolean = false>(
    options: Options<DeletePaymentBatchData, ThrowOnError>,
  ): RequestResult<DeletePaymentBatchResponses, DeletePaymentBatchErrors, ThrowOnError> {
    return (options.client ?? this.client).delete<
      DeletePaymentBatchResponses,
      DeletePaymentBatchErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zDeletePaymentBatchHeaders,
            path: zDeletePaymentBatchPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseValidator: async (data) => await deletePaymentBatchResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}',
      ...options,
    });
  }

  /**
   * Get payment batch
   */
  public getPaymentBatch<ThrowOnError extends boolean = false>(
    options: Options<GetPaymentBatchData, ThrowOnError>,
  ): RequestResult<GetPaymentBatchResponses, GetPaymentBatchErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetPaymentBatchResponses,
      GetPaymentBatchErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetPaymentBatchHeaders,
            path: zGetPaymentBatchPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getPaymentBatchResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}',
      ...options,
    });
  }

  /**
   * Update payment batch
   *
   * Allowed while the batch is `loading` or `draft`. Re-declaring `expectedItemCount` re-decides which of the two the batch is in: set it to the number of rows already loaded and the upload closes; set it above and a `draft` batch reopens as `loading` so the missing rows can be sent. Sending the value it already has changes neither. Changing the account does not reset verification.
   */
  public updatePaymentBatch<ThrowOnError extends boolean = false>(
    options: Options<UpdatePaymentBatchData, ThrowOnError>,
  ): RequestResult<UpdatePaymentBatchResponses, UpdatePaymentBatchErrors, ThrowOnError> {
    return (options.client ?? this.client).patch<
      UpdatePaymentBatchResponses,
      UpdatePaymentBatchErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zUpdatePaymentBatchBody,
            headers: zUpdatePaymentBatchHeaders,
            path: zUpdatePaymentBatchPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await updatePaymentBatchResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Remove payment batch items
   *
   * Removes rows by id, by status (e.g. ["invalid"] to drop the rejected rows), or all of them. Exactly one selector is required. The batch itself survives; removing every row returns it to `loading` with `expectedItemCount` unchanged, so the same file can be uploaded again. A partial removal instead lowers `expectedItemCount` to the rows that remain, and is allowed only while the batch is `draft` — a `loading` batch is still receiving the file it declared, so `all: true` is the only removal it accepts.
   */
  public removePaymentBatchItems<ThrowOnError extends boolean = false>(
    options: Options<RemovePaymentBatchItemsData, ThrowOnError>,
  ): RequestResult<RemovePaymentBatchItemsResponses, RemovePaymentBatchItemsErrors, ThrowOnError> {
    return (options.client ?? this.client).delete<
      RemovePaymentBatchItemsResponses,
      RemovePaymentBatchItemsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zRemovePaymentBatchItemsBody,
            headers: zRemovePaymentBatchItemsHeaders,
            path: zRemovePaymentBatchItemsPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await removePaymentBatchItemsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}/items',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * List payment batch items
   *
   * Paginated, in upload order. Also the execution report: ?status=failed returns the rows with errorCode/error populated.
   */
  public listPaymentBatchItems<ThrowOnError extends boolean = false>(
    options: Options<ListPaymentBatchItemsData, ThrowOnError>,
  ): RequestResult<ListPaymentBatchItemsResponses, ListPaymentBatchItemsErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      ListPaymentBatchItemsResponses,
      ListPaymentBatchItemsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zListPaymentBatchItemsHeaders,
            path: zListPaymentBatchItemsPath,
            query: zListPaymentBatchItemsQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await listPaymentBatchItemsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}/items',
      ...options,
    });
  }

  /**
   * Add items to a payment batch
   *
   * Loads every row. Rows failing validation are stored with status `invalid` and a `validationErrors` list rather than rejecting the request, so one bad row cannot discard a 10,000-row upload. Allowed only while the batch is `loading`; the batch settles to `draft` once its `expectedItemCount` is reached. To append to a `draft` batch, raise `expectedItemCount` via PATCH /:id first.
   */
  public addPaymentBatchItems<ThrowOnError extends boolean = false>(
    options: Options<AddPaymentBatchItemsData, ThrowOnError>,
  ): RequestResult<AddPaymentBatchItemsResponses, AddPaymentBatchItemsErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      AddPaymentBatchItemsResponses,
      AddPaymentBatchItemsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zAddPaymentBatchItemsBody,
            headers: zAddPaymentBatchItemsHeaders,
            path: zAddPaymentBatchItemsPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await addPaymentBatchItemsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}/items',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Edit a payment batch item
   *
   * Replaces one item and re-validates it whole. Allowed while the batch is `loading` or `draft`. `rowId` is not editable: omit it or send the value the row already has, never a different one. A row that no longer passes validation becomes `invalid`; otherwise it returns to `pending` for re-verification — unless a settled VoP result stands and neither the counterparty name nor the IBAN changed, in which case that result is kept.
   */
  public updatePaymentBatchItem<ThrowOnError extends boolean = false>(
    options: Options<UpdatePaymentBatchItemData, ThrowOnError>,
  ): RequestResult<UpdatePaymentBatchItemResponses, UpdatePaymentBatchItemErrors, ThrowOnError> {
    return (options.client ?? this.client).patch<
      UpdatePaymentBatchItemResponses,
      UpdatePaymentBatchItemErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zUpdatePaymentBatchItemBody,
            headers: zUpdatePaymentBatchItemHeaders,
            path: zUpdatePaymentBatchItemPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await updatePaymentBatchItemResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}/items/{itemId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Force-approve a payment batch item that failed VoP
   *
   * Overrides a failed VoP verdict so the item can still be submitted: `verification_failed` becomes `verification_overridden`. Allowed only while the batch is draft. The verdict is kept on the row for audit, and re-verification skips it — those rounds read only `pending` rows. A `dry_run_failed` row is **not** overridable and answers 422: the provider declined to price it, so there is no previewed fee and no previewed total to authorize. Fix that row and re-run the dry run, or remove it.
   */
  public forceApprovePaymentBatchItem<ThrowOnError extends boolean = false>(
    options: Options<ForceApprovePaymentBatchItemData, ThrowOnError>,
  ): RequestResult<
    ForceApprovePaymentBatchItemResponses,
    ForceApprovePaymentBatchItemErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      ForceApprovePaymentBatchItemResponses,
      ForceApprovePaymentBatchItemErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zForceApprovePaymentBatchItemHeaders,
            path: zForceApprovePaymentBatchItemPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await forceApprovePaymentBatchItemResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}/items/{itemId}/actions/force-approve',
      ...options,
    });
  }

  /**
   * Force-approve payment batch items that failed VoP in bulk
   *
   * The bulk form of POST /:id/items/:itemId/actions/force-approve, for a batch whose failures run into the thousands: one request instead of one per row. Overrides rows by id, or every overridable row with `all: true` — exactly one selector is required. Allowed only while the batch is draft. Rows that did not fail VoP are skipped rather than rejected — `dry_run_failed` rows among them, which are never overridable — so a retry is idempotent; `approved` reports how many actually moved.
   */
  public forceApprovePaymentBatchItems<ThrowOnError extends boolean = false>(
    options: Options<ForceApprovePaymentBatchItemsData, ThrowOnError>,
  ): RequestResult<
    ForceApprovePaymentBatchItemsResponses,
    ForceApprovePaymentBatchItemsErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      ForceApprovePaymentBatchItemsResponses,
      ForceApprovePaymentBatchItemsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zForceApprovePaymentBatchItemsBody,
            headers: zForceApprovePaymentBatchItemsHeaders,
            path: zForceApprovePaymentBatchItemsPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await forceApprovePaymentBatchItemsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}/items/actions/force-approve',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Verify a payment batch against VoP
   *
   * Starts asynchronous VoP verification of every pending item. Allowed only while the batch is draft — a run already in flight owns it. A batch with no pending items is returned unchanged without starting a run. Poll GET /:id and watch summary.byStatus.pending reach 0. Only an exact name match passes; close-match and not-applicable land in `verification_failed` for a human to force-approve.
   */
  public verifyPaymentBatch<ThrowOnError extends boolean = false>(
    options: Options<VerifyPaymentBatchData, ThrowOnError>,
  ): RequestResult<VerifyPaymentBatchResponses, VerifyPaymentBatchErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      VerifyPaymentBatchResponses,
      VerifyPaymentBatchErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zVerifyPaymentBatchHeaders,
            path: zVerifyPaymentBatchPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await verifyPaymentBatchResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}/actions/verify',
      ...options,
    });
  }

  /**
   * Price an outgoing payment batch against Integrated Finance
   *
   * Starts the asynchronous dry run: every row VoP has settled is routed (a destination at our own bank routes internally and creates no beneficiary; anywhere else creates or reuses one), re-validated against its destination, and priced — `summary.dryRunFeeTotal` and `summary.dryRunGrandTotal`, and `dryRun` on each item; `summary.dryRunFailedAmountTotal` sums the rows it could not price. Whether the row rail reaches the destination bank is checked before any beneficiary is created, so an unreachable row costs no payee. Outgoing batches only; an incoming batch answers 404. Allowed only while the batch is draft and no row is `pending`, `invalid` or `verification_failed`: verification has to have finished and been accepted first, and pricing around a row that cannot execute would preview a batch that cannot submit. Fix an `invalid` row with PATCH, force-approve or fix a `verification_failed` one, or remove the row. A batch with nothing left to price and no `dry_run_failed` row is returned unchanged without starting a run. Pressing again is the retry: it re-prices every `dry_run_failed` row and every row an edit left unpriced, and touches nothing already priced. Rows IF refuses land in `dry_run_failed` with an `errorCode`. Those are **not** force-approvable — the provider declined to quote the payment, so there is no fee and no total to authorize, exactly as a single transfer IF will not price is refused outright. Press again, fix the row with PATCH first, or remove it; until then the batch will not submit. Poll GET /:id and watch the batch leave `dry_running`.
   */
  public dryRunPaymentBatch<ThrowOnError extends boolean = false>(
    options: Options<DryRunPaymentBatchData, ThrowOnError>,
  ): RequestResult<DryRunPaymentBatchResponses, DryRunPaymentBatchErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      DryRunPaymentBatchResponses,
      DryRunPaymentBatchErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zDryRunPaymentBatchHeaders,
            path: zDryRunPaymentBatchPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await dryRunPaymentBatchResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}/actions/dry-run',
      ...options,
    });
  }

  /**
   * Request authorization to submit a payment batch
   *
   * Starts a CIBA challenge for the batch the user is about to authorize; nothing is sent until it is approved and passed to POST /:id/actions/resolve-submit-challenge. The batch stays editable meanwhile, so the approved figures are re-derived and compared before anything is scheduled. Every submit guard runs here too: allowed only while the batch is draft. Takes no body. Poll the challenge via GET /v1/challenges/{challengeId}.
   *
   * **Incoming (SDD):** every item must be verified or force-approved. The push carries the number of collections, the total, the currency, the collection date and the batch reference. `submitAt` and `settlementDate` are set with PATCH /:id, so the dates live in one place and one place only. A batch with no `submitAt` is submitted immediately. `settlementDate` must be a TARGET2 business day (weekdays minus the six ECB closing days) between tomorrow and 14 days out, and `submitAt` must fall on or before 10:30 Europe/Vilnius on the last TARGET2 business day before it.
   *
   * **Outgoing:** every item must be `dry_run_completed` — a `verified` or `verification_overridden` row has not been priced; press POST /:id/actions/dry-run. Its `dryRunGrandTotal`, plus what other submitted outgoing batches on the same account have not sent yet, is checked against the source account available balance. The push carries the number of payments, the grand total, the fee total and the batch reference; the currency, the amount total and the grand total are also bound. The batch is sent as soon as the challenge is resolved.
   */
  public initiatePaymentBatchSubmitChallenge<ThrowOnError extends boolean = false>(
    options: Options<InitiatePaymentBatchSubmitChallengeData, ThrowOnError>,
  ): RequestResult<
    InitiatePaymentBatchSubmitChallengeResponses,
    InitiatePaymentBatchSubmitChallengeErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      InitiatePaymentBatchSubmitChallengeResponses,
      InitiatePaymentBatchSubmitChallengeErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zInitiatePaymentBatchSubmitChallengeHeaders,
            path: zInitiatePaymentBatchSubmitChallengePath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await initiatePaymentBatchSubmitChallengeResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}/actions/initiate-submit-challenge',
      ...options,
    });
  }

  /**
   * Resolve the challenge and submit the payment batch
   *
   * Consumes an approved submission challenge, freezes the batch and hands it to execution. The batch is re-checked against the approved figures and rejected if any of them moved while the challenge was pending — an edit or a re-price between initiate and resolve needs a new challenge. An incoming batch is scheduled for its collection date; an outgoing one is re-checked against the balance and its transfers are created at once, each under its own item id as the idempotency key. Only one submit per IF client is processed at a time.
   */
  public resolvePaymentBatchSubmitChallenge<ThrowOnError extends boolean = false>(
    options: Options<ResolvePaymentBatchSubmitChallengeData, ThrowOnError>,
  ): RequestResult<
    ResolvePaymentBatchSubmitChallengeResponses,
    ResolvePaymentBatchSubmitChallengeErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      ResolvePaymentBatchSubmitChallengeResponses,
      ResolvePaymentBatchSubmitChallengeErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zResolvePaymentBatchSubmitChallengeBody,
            headers: zResolvePaymentBatchSubmitChallengeHeaders,
            path: zResolvePaymentBatchSubmitChallengePath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await resolvePaymentBatchSubmitChallengeResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}/actions/resolve-submit-challenge',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Cancel a payment batch
   *
   * Calls off a batch that is scheduled but not yet sent. Cancellation is a soft state, not a delete: the rows stay for audit. A batch still in draft was never scheduled — delete it instead. Incoming (SDD) only: an outgoing batch answers 404, because resolving its submit challenge starts execution at once and leaves no window in which cancelling would mean anything. Stopping an outgoing payment is a per-transfer recall, not a batch action.
   */
  public cancelPaymentBatch<ThrowOnError extends boolean = false>(
    options: Options<CancelPaymentBatchData, ThrowOnError>,
  ): RequestResult<CancelPaymentBatchResponses, CancelPaymentBatchErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      CancelPaymentBatchResponses,
      CancelPaymentBatchErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zCancelPaymentBatchHeaders,
            path: zCancelPaymentBatchPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await cancelPaymentBatchResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}/actions/cancel',
      ...options,
    });
  }

  /**
   * Clone a payment batch
   *
   * Copies the batch's rows into a new draft owned by the caller. Allowed from any source status, including `executing` and the terminal ones — the source is read-only here and stays the record of what happened. The account and every row's content carry over; `submitAt` and `settlementDate` do not, because dates valid for the source are almost certainly outside the presentation window now. Each row is re-validated as if freshly uploaded, gets a new endToEndId, and starts unverified — rows that no longer pass a content rule land as `invalid` rather than failing the clone. Items are not inlined: fetch them via GET /:newId/items.
   */
  public clonePaymentBatch<ThrowOnError extends boolean = false>(
    options: Options<ClonePaymentBatchData, ThrowOnError>,
  ): RequestResult<ClonePaymentBatchResponses, ClonePaymentBatchErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      ClonePaymentBatchResponses,
      ClonePaymentBatchErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zClonePaymentBatchBody,
            headers: zClonePaymentBatchHeaders,
            path: zClonePaymentBatchPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await clonePaymentBatchResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/payment-batches/{id}/actions/clone',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Terminate all other sessions
   *
   * Revokes all sessions except the current one.
   */
  public deleteAllOtherSessions<ThrowOnError extends boolean = false>(
    options: Options<DeleteAllOtherSessionsData, ThrowOnError>,
  ): RequestResult<DeleteAllOtherSessionsResponses, DeleteAllOtherSessionsErrors, ThrowOnError> {
    return (options.client ?? this.client).delete<
      DeleteAllOtherSessionsResponses,
      DeleteAllOtherSessionsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zDeleteAllOtherSessionsHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseValidator: async (data) => await deleteAllOtherSessionsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/sessions',
      ...options,
    });
  }

  /**
   * List active sessions
   *
   * Retrieves all active Auth0 sessions for the authenticated user.
   */
  public getActiveSessions<ThrowOnError extends boolean = false>(
    options: Options<GetActiveSessionsData, ThrowOnError>,
  ): RequestResult<GetActiveSessionsResponses, GetActiveSessionsErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetActiveSessionsResponses,
      GetActiveSessionsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetActiveSessionsHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getActiveSessionsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/sessions',
      ...options,
    });
  }

  /**
   * Log out
   *
   * Revokes the current session. The next login requires full re-authentication.
   */
  public deleteCurrentSession<ThrowOnError extends boolean = false>(
    options: Options<DeleteCurrentSessionData, ThrowOnError>,
  ): RequestResult<DeleteCurrentSessionResponses, DeleteCurrentSessionErrors, ThrowOnError> {
    return (options.client ?? this.client).delete<
      DeleteCurrentSessionResponses,
      DeleteCurrentSessionErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zDeleteCurrentSessionHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseValidator: async (data) => await deleteCurrentSessionResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/sessions/current',
      ...options,
    });
  }

  /**
   * Terminate a specific session
   *
   * Revokes a specific session by ID. Cannot revoke the current session.
   */
  public deleteSession<ThrowOnError extends boolean = false>(
    options: Options<DeleteSessionData, ThrowOnError>,
  ): RequestResult<DeleteSessionResponses, DeleteSessionErrors, ThrowOnError> {
    return (options.client ?? this.client).delete<
      DeleteSessionResponses,
      DeleteSessionErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zDeleteSessionHeaders,
            path: zDeleteSessionPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseValidator: async (data) => await deleteSessionResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/sessions/{sid}',
      ...options,
    });
  }

  /**
   * Evaluate login
   *
   * Evaluates whether a login session requires liveness enforcement, MFA, and whether the originating country is allowed. Returns additional JWT claims for the Auth0 Post-Login Action. Called by Auth0 Post-Login Action on every login and refresh token exchange.
   */
  public evaluateLogin<ThrowOnError extends boolean = false>(
    options: Options<EvaluateLoginData, ThrowOnError>,
  ): RequestResult<EvaluateLoginResponses, EvaluateLoginErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      EvaluateLoginResponses,
      EvaluateLoginErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zEvaluateLoginBody,
            path: zEvaluateLoginPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await evaluateLoginResponse.parseAsync(data),
      security: [{ name: 'x-api-key', type: 'apiKey' }],
      url: '/v1/sessions/{id}/actions/evaluate-login',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Evaluate registration
   *
   * Evaluates whether a registration attempt is allowed based on the country derived from Auth0 geoip. Called by Auth0 Pre-User-Registration Action.
   */
  public evaluateRegistration<ThrowOnError extends boolean = false>(
    options: Options<EvaluateRegistrationData, ThrowOnError>,
  ): RequestResult<EvaluateRegistrationResponses, EvaluateRegistrationErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      EvaluateRegistrationResponses,
      EvaluateRegistrationErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zEvaluateRegistrationBody,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await evaluateRegistrationResponse.parseAsync(data),
      security: [{ name: 'x-api-key', type: 'apiKey' }],
      url: '/v1/registrations/actions/evaluate-registration',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Collect user basic info
   *
   * Collects and persists first and last name for the given user. Users can only submit their own info — returns 403 if :id does not match the authenticated user. Can only be set once — returns 409 if already set.
   */
  public collectBasicInfo<ThrowOnError extends boolean = false>(
    options: Options<CollectBasicInfoData, ThrowOnError>,
  ): RequestResult<CollectBasicInfoResponses, CollectBasicInfoErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      CollectBasicInfoResponses,
      CollectBasicInfoErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zCollectBasicInfoBody,
            headers: zCollectBasicInfoHeaders,
            path: zCollectBasicInfoPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await collectBasicInfoResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/users/{id}/basic-info',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get user contexts
   *
   * Returns the organizations the authenticated user has access to.
   */
  public getUserContexts<ThrowOnError extends boolean = false>(
    options: Options<GetUserContextsData, ThrowOnError>,
  ): RequestResult<GetUserContextsResponses, GetUserContextsErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetUserContextsResponses,
      GetUserContextsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetUserContextsHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getUserContextsResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/users/contexts',
      ...options,
    });
  }

  /**
   * Get profile picture URL
   *
   * Generates a presigned URL for accessing a user's profile picture. Any authenticated user can access any other user's profile picture.
   */
  public getProfilePictureUrl<ThrowOnError extends boolean = false>(
    options: Options<GetProfilePictureUrlData, ThrowOnError>,
  ): RequestResult<GetProfilePictureUrlResponses, GetProfilePictureUrlErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetProfilePictureUrlResponses,
      GetProfilePictureUrlErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetProfilePictureUrlHeaders,
            path: zGetProfilePictureUrlPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getProfilePictureUrlResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/users/{id}/profile-picture',
      ...options,
    });
  }

  /**
   * Get profile picture upload URL
   *
   * Generates a presigned URL for uploading a profile picture. Users can only upload their own profile picture.
   */
  public getProfilePictureUploadUrl<ThrowOnError extends boolean = false>(
    options: Options<GetProfilePictureUploadUrlData, ThrowOnError>,
  ): RequestResult<
    GetProfilePictureUploadUrlResponses,
    GetProfilePictureUploadUrlErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).put<
      GetProfilePictureUploadUrlResponses,
      GetProfilePictureUploadUrlErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetProfilePictureUploadUrlHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getProfilePictureUploadUrlResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/users/profile-picture',
      ...options,
    });
  }

  /**
   * Get user by ID
   *
   * Retrieves user details for the authenticated user. Users can only access their own data.
   */
  public getUserById<ThrowOnError extends boolean = false>(
    options: Options<GetUserByIdData, ThrowOnError>,
  ): RequestResult<GetUserByIdResponses, GetUserByIdErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetUserByIdResponses,
      GetUserByIdErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetUserByIdHeaders,
            path: zGetUserByIdPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getUserByIdResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/users/{id}',
      ...options,
    });
  }

  /**
   * Set account liveness lock
   *
   * Sets a Redis-backed account-level liveness block for the user. Called by Auth0 Post-Change-Password Action after password reset.
   */
  public setAccountLivenessLock<ThrowOnError extends boolean = false>(
    options: Options<SetAccountLivenessLockData, ThrowOnError>,
  ): RequestResult<SetAccountLivenessLockResponses, SetAccountLivenessLockErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      SetAccountLivenessLockResponses,
      SetAccountLivenessLockErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            path: zSetAccountLivenessLockPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await setAccountLivenessLockResponse.parseAsync(data),
      security: [{ name: 'x-api-key', type: 'apiKey' }],
      url: '/v1/users/{id}/actions/set-account-liveness-lock',
      ...options,
    });
  }

  /**
   * Get KYC verification status
   *
   * Retrieves KYC verification status and applicant details for the authenticated user. Returns transformed data with computed fields like kycStatus (GREEN/RED/RETRY) and idDocExpiresAt. Users can only access their own KYC status.
   */
  public getKycStatus<ThrowOnError extends boolean = false>(
    options: Options<GetKycStatusData, ThrowOnError>,
  ): RequestResult<GetKycStatusResponses, GetKycStatusErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetKycStatusResponses,
      GetKycStatusErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetKycStatusHeaders,
            path: zGetKycStatusPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getKycStatusResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/verifications/{id}/kyc',
      ...options,
    });
  }

  /**
   * Generate KYC verification link
   *
   * Creates a personalized KYC verification link for the authenticated user. The link redirects to Sumsub WebSDK where the user can complete their identity verification. Users can only generate verification links for themselves.
   */
  public generateKycLink<ThrowOnError extends boolean = false>(
    options: Options<GenerateKycLinkData, ThrowOnError>,
  ): RequestResult<GenerateKycLinkResponses, GenerateKycLinkErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      GenerateKycLinkResponses,
      GenerateKycLinkErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zGenerateKycLinkBody,
            headers: zGenerateKycLinkHeaders,
            path: zGenerateKycLinkPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await generateKycLinkResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/verifications/{id}/kyc',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get KYB verification status
   *
   * Retrieves KYB verification status and applicant details for the organization. Returns transformed data with computed fields like kybStatus (GREEN/RED/RETRY). Requires an ID token with org_id claim matching the path parameter.
   */
  public getKybStatus<ThrowOnError extends boolean = false>(
    options: Options<GetKybStatusData, ThrowOnError>,
  ): RequestResult<GetKybStatusResponses, GetKybStatusErrors, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetKybStatusResponses,
      GetKybStatusErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGetKybStatusHeaders,
            path: zGetKybStatusPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getKybStatusResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/verifications/{organizationId}/kyb',
      ...options,
    });
  }

  /**
   * Generate KYB verification link
   *
   * Creates a KYB verification link for the organization. The link redirects to Sumsub WebSDK where the user can complete business verification. Requires an ID token with org_id claim matching the path parameter.
   */
  public generateKybLink<ThrowOnError extends boolean = false>(
    options: Options<GenerateKybLinkData, ThrowOnError>,
  ): RequestResult<GenerateKybLinkResponses, GenerateKybLinkErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      GenerateKybLinkResponses,
      GenerateKybLinkErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zGenerateKybLinkHeaders,
            path: zGenerateKybLinkPath,
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await generateKybLinkResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/verifications/{organizationId}/kyb',
      ...options,
    });
  }

  /**
   * Start SEPA Creditor Identifier collection
   *
   * Creates a Sumsub applicant action for the SDD creditor identifier questionnaire and returns a hosted WebSDK URL. The organization is taken from the org_id claim of the ID token. Fails with 409 when the organization already has a creditor identifier, or was finally rejected for SDD. An outstanding attempt may be restarted — doing so supersedes it.
   */
  public startSddCreditorCollection<ThrowOnError extends boolean = false>(
    options: Options<StartSddCreditorCollectionData, ThrowOnError>,
  ): RequestResult<
    StartSddCreditorCollectionResponses,
    StartSddCreditorCollectionErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      StartSddCreditorCollectionResponses,
      StartSddCreditorCollectionErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zStartSddCreditorCollectionHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await startSddCreditorCollectionResponse.parseAsync(data),
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/v1/organizations/actions/start-sdd-creditor-id-collection',
      ...options,
    });
  }

  /**
   * Decode encrypted Temporal payloads
   *
   * Decrypts Temporal workflow payloads for the Temporal Web UI codec server. No auth required for local dev (TEMPORAL_JWKS_URL not set). For Temporal Cloud, TEMPORAL_JWKS_URL is set and the signed-in user token is sent automatically.
   */
  public decodeTemporalPayloads<ThrowOnError extends boolean = false>(
    options: Options<DecodeTemporalPayloadsData, ThrowOnError>,
  ): RequestResult<DecodeTemporalPayloadsResponses, DecodeTemporalPayloadsErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      DecodeTemporalPayloadsResponses,
      DecodeTemporalPayloadsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zDecodeTemporalPayloadsBody,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await decodeTemporalPayloadsResponse.parseAsync(data),
      url: '/v1/temporal/codec/decode',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Check upstream API connectivity
   *
   * Reports reachability of configured upstream APIs for connectivity testing and logging. Always returns 200 — a failing upstream never affects this endpoint or the application's own health check. Upstreams are keyed by an opaque id and results are cached for 30s.
   */
  public checkUpstreamHealth<ThrowOnError extends boolean = false>(
    options?: Options<CheckUpstreamHealthData, ThrowOnError>,
  ): RequestResult<CheckUpstreamHealthResponses, CheckUpstreamHealthErrors, ThrowOnError> {
    return (options?.client ?? this.client).get<
      CheckUpstreamHealthResponses,
      CheckUpstreamHealthErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await checkUpstreamHealthResponse.parseAsync(data),
      url: '/v1/health/upstream',
      ...options,
    });
  }

  /**
   * Receive and process Auth0 event stream webhook
   *
   * Receives an Auth0 event stream webhook and processes it synchronously
   */
  public receiveAuth0Webhook<ThrowOnError extends boolean = false>(
    options: Options<ReceiveAuth0WebhookData, ThrowOnError>,
  ): RequestResult<ReceiveAuth0WebhookResponses, ReceiveAuth0WebhookErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      ReceiveAuth0WebhookResponses,
      ReceiveAuth0WebhookErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zReceiveAuth0WebhookBody,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await receiveAuth0WebhookResponse.parseAsync(data),
      url: '/v1/webhooks/auth0',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Receive Auth0 log stream events
   *
   * Receives Auth0 log stream webhook events and processes login audit events
   */
  public receiveAuth0LogStream<ThrowOnError extends boolean = false>(
    options: Options<ReceiveAuth0LogStreamData, ThrowOnError>,
  ): RequestResult<ReceiveAuth0LogStreamResponses, ReceiveAuth0LogStreamErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      ReceiveAuth0LogStreamResponses,
      ReceiveAuth0LogStreamErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zReceiveAuth0LogStreamBody,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await receiveAuth0LogStreamResponse.parseAsync(data),
      url: '/v1/webhooks/auth0/logs',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Receive and process Integrated Finance webhook
   *
   * Receives an Integrated Finance webhook and processes it synchronously
   */
  public receiveIntegratedFinanceWebhook<ThrowOnError extends boolean = false>(
    options: Options<ReceiveIntegratedFinanceWebhookData, ThrowOnError>,
  ): RequestResult<
    ReceiveIntegratedFinanceWebhookResponses,
    ReceiveIntegratedFinanceWebhookErrors,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      ReceiveIntegratedFinanceWebhookResponses,
      ReceiveIntegratedFinanceWebhookErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: zReceiveIntegratedFinanceWebhookBody,
            headers: zReceiveIntegratedFinanceWebhookHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await receiveIntegratedFinanceWebhookResponse.parseAsync(data),
      url: '/v1/webhooks/integrated-finance',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Receive and process Sumsub webhook
   *
   * Receives a Sumsub webhook (e.g., applicantActionReviewed) and processes it synchronously
   */
  public receiveSumsubWebhook<ThrowOnError extends boolean = false>(
    options: Options<ReceiveSumsubWebhookData, ThrowOnError>,
  ): RequestResult<ReceiveSumsubWebhookResponses, ReceiveSumsubWebhookErrors, ThrowOnError> {
    return (options.client ?? this.client).post<
      ReceiveSumsubWebhookResponses,
      ReceiveSumsubWebhookErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            headers: zReceiveSumsubWebhookHeaders,
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await receiveSumsubWebhookResponse.parseAsync(data),
      url: '/v1/webhooks/sumsub',
      ...options,
    });
  }

  /**
   * Receive Auth0 backchannel logout notification
   *
   * Receives a backchannel logout token from Auth0 and blacklists the session ID.
   */
  public receiveBackchannelLogout<ThrowOnError extends boolean = false>(
    options?: Options<ReceiveBackchannelLogoutData, ThrowOnError>,
  ): RequestResult<
    ReceiveBackchannelLogoutResponses,
    ReceiveBackchannelLogoutErrors,
    ThrowOnError
  > {
    return (options?.client ?? this.client).post<
      ReceiveBackchannelLogoutResponses,
      ReceiveBackchannelLogoutErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      url: '/v1/webhooks/auth0/backchannel-logout',
      ...options,
    });
  }

  /**
   * Get default application metrics
   *
   * Returns NestJS application metrics from @willsoto/nestjs-prometheus in Prometheus text format. Includes custom upstream module http metrics.
   */
  public getDefaultMetrics<ThrowOnError extends boolean = false>(
    options?: Options<GetDefaultMetricsData, ThrowOnError>,
  ): RequestResult<GetDefaultMetricsResponses, GetDefaultMetricsErrors, ThrowOnError> {
    return (options?.client ?? this.client).get<
      GetDefaultMetricsResponses,
      GetDefaultMetricsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getDefaultMetricsResponse.parseAsync(data),
      url: '/metrics/default',
      ...options,
    });
  }

  /**
   * Get Express HTTP metrics
   *
   * Returns HTTP request/response metrics from express-prom-bundle in Prometheus text format. These metrics describe the load and usage of our API from connected clients.
   */
  public getExpressMetrics<ThrowOnError extends boolean = false>(
    options?: Options<GetExpressMetricsData, ThrowOnError>,
  ): RequestResult<GetExpressMetricsResponses, GetExpressMetricsErrors, ThrowOnError> {
    return (options?.client ?? this.client).get<
      GetExpressMetricsResponses,
      GetExpressMetricsErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await getExpressMetricsResponse.parseAsync(data),
      url: '/metrics/express',
      ...options,
    });
  }

  /**
   * Check application health
   *
   * Returns health status of the application including database, Redis, and uptime checks.
   */
  public checkHealth<ThrowOnError extends boolean = false>(
    options?: Options<CheckHealthData, ThrowOnError>,
  ): RequestResult<CheckHealthResponses, CheckHealthErrors, ThrowOnError> {
    return (options?.client ?? this.client).get<
      CheckHealthResponses,
      CheckHealthErrors,
      ThrowOnError
    >({
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) => await checkHealthResponse.parseAsync(data),
      url: '/v1/health',
      ...options,
    });
  }
}
